import React, { useState, useMemo, useRef, useEffect } from "react";

// Shown whenever a Talk or Voices generation fails, for any reason.
const FUND_MESSAGE = "Something went wrong generating a response. Please try again later.";


const QUOTES = [
  // ── SEASON 1 ──
  { id: 1, text: "I need you to tell me that I'm a good person.", character: "BoJack Horseman", episode: "Downer Ending", season: 1 },
  { id: 3, text: "I don't understand how people live. It's amazing to me that people wake up every morning and say 'Yeah, another day, let's do it.'", character: "BoJack Horseman", episode: "Later", season: 1 },
  { id: 4, text: "Closure is a made up thing by Steven Spielberg to sell movie tickets.", character: "BoJack Horseman", episode: "BoJack Hates the Troops", season: 1 },
  { id: 5, text: "There is no shame in dying for nothing. That's why most people die.", character: "BoJack Horseman", episode: "BoJack Hates the Troops", season: 1 },
  { id: 8, text: "I don't buy the idea that some people are just born bad. I think people are just people, and circumstances shape who they become.", character: "Diane Nguyen", episode: "The Telescope", season: 1 },
  { id: 9, text: "You know what your problem is? You want to think of yourself as the good guy. Well, I know you, BoJack Horseman. And, no. You are not.", character: "Herb Kazzaz", episode: "The Telescope", season: 1 },
  { id: 12, text: "Back in the '90s I was in a very famous TV show.", character: "BoJack Horseman", episode: "The BoJack Horseman Story, Chapter One", season: 1 },

  // ── SEASON 2 ──
  { id: 14, text: "Every day it gets a little easier. But you gotta do it every day. That's the hard part. But it does get easier.", character: "Jogging Baboon", episode: "Brand New Couch", season: 2 },
  { id: 15, text: "I'm responsible for my own happiness? I can't even be responsible for my own breakfast.", character: "BoJack Horseman", episode: "Brand New Couch", season: 2 },
  { id: 16, text: "When you look at someone through rose-colored glasses, all the red flags just look like flags.", character: "Wanda Pierce", episode: "Yesterdayland", season: 2 },
  { id: 17, text: "The universe is a cruel, uncaring void. The key to being happy isn't a search for meaning. It's to just keep yourself busy with unimportant nonsense, and eventually, you'll be dead.", character: "Mr. Peanutbutter", episode: "Hank After Dark", season: 2 },
  { id: 71, text: "You have to be careful, because if you spend a lot of time with stories, you start to believe that life is just stories, and it's not.", character: "Princess Carolyn", episode: "The BoJack Horseman Story, Chapter One", season: 1 },
  { id: 72, text: "I have to push a boulder up a hill and then have it roll over me time and time again with no regard for my well-being!", character: "Princess Carolyn", episode: "Later", season: 1 },
  { id: 73, text: "When you're good at putting out fires, you just run from fire to fire without thinking.", character: "BoJack Horseman", episode: "Best Thing That Ever Happened", season: 3 },
  { id: 23, text: "You were born with a sack of doorknobs and every door you open, you lose one. That's life.", character: "BoJack Horseman", episode: "Later", season: 2 },

  // ── SEASON 3 ──
  { id: 24, text: "You can't keep doing shitty things and then feel bad about yourself like that makes it okay.", character: "Todd Chavez", episode: "That's Too Much, Man!", season: 3 },
  { id: 25, text: "You are all the things that are wrong with you. It's not the alcohol, or the drugs, or any of the shitty things that happened to you. It's you.", character: "Todd Chavez", episode: "That's Too Much, Man!", season: 3 },

  // ── SEASON 4 ──
  { id: 34, text: "It takes a long time to realize how truly miserable you are and even longer to see it doesn't have to be that way.", character: "BoJack Horseman", episode: "Stupid Piece of Sh*t", season: 4 },
  { id: 35, text: "Family is a sinkhole, and you were right to get out when you did.", character: "BoJack Horseman", episode: "Stupid Piece of Sh*t", season: 4 },
  { id: 36, text: "Time's a flat circle, and we're all just riding it into the ground.", character: "BoJack Horseman", episode: "Time's Arrow", season: 4 },
  { id: 39, text: "The hardest part of being a mother is that you can't control who your child becomes.", character: "Beatrice Horseman", episode: "Time's Arrow", season: 4 },
  { id: 42, text: "BoJack, just because you're broken doesn't mean you get to break things.", character: "Hollyhock", episode: "What Time Is It Right Now", season: 4 },

  // ── SEASON 5 ──
  { id: 45, text: "I don't know when I stopped dreaming about what I wanted my life to look like and just started reacting to whatever's in front of me.", character: "Diane Nguyen", episode: "The Dog Days Are Over", season: 5 },
  { id: 46, text: "Free Churro.", character: "BoJack Horseman", episode: "Free Churro", season: 5 },
  { id: 68, text: "I see you. That's what she said. Her last words to me. I see you. ...She was reading the sign on the wall. I.C.U. She wasn't talking to me at all.", character: "BoJack Horseman", episode: "Free Churro", season: 5 },
  { id: 48, text: "Here's what I know about people: everyone is doing the best they can with what they've been given.", character: "Princess Carolyn", episode: "Planned Obsolescence", season: 5 },
  { id: 49, text: "The one thing that I know about wanting things is that it never ends. You get what you want and you just find something new to want.", character: "BoJack Horseman", episode: "BoJack the Feminist", season: 5 },
  { id: 50, text: "You know what? I think there are people who help you become the person that you end up being, and you can be grateful for them even if they were never meant to be in your life forever.", character: "Diane Nguyen", episode: "Ancient History", season: 5 },
  { id: 67, text: "The only way out is through.", character: "Princess Carolyn", episode: "The Horny Unicorn", season: 5 },

  // ── SEASON 6 ──
  { id: 57, text: "The thing about being sober is, you still have all your problems. You just have them more clearly.", character: "BoJack Horseman", episode: "A Horse Walks into a Rehab", season: 6 },
];

const CHARACTERS = [
  // ── MAIN CAST ──
  { id: 1, name: "BoJack Horseman", species: "Horse", role: "Main", description: "Former star of 90s sitcom Horsin' Around. Funny, self-destructive, and self-aware enough to name every one of his flaws — which doesn't always mean he changes them. The show's central question is whether that's possible. After six seasons the answer is: sort of, slowly, incompletely. He survives.", actor: "Will Arnett" },
  { id: 2, name: "Princess Carolyn", species: "Cat", role: "Main", description: "Agent, manager, producer — always the most competent person in the room, always the one holding everything together. The work is real but it's also the thing she reaches for instead of sitting with anything harder. She catches glimpses of this. She just never stops long enough to ask why.", actor: "Amy Sedaris" },
  { id: 3, name: "Diane Nguyen", species: "Human", role: "Main", description: "Writer and BoJack's ghostwriter. Thoughtful, idealistic, and prone to self-sabotage. Her S6 arc follows her through depression and a slow, unglamorous recovery in Chicago — she gains weight, cuts her hair, starts medication, and gets quieter and more okay. The show treats it as a good thing. Recovery doesn't look like a glow-up. It looks like someone who started actually living.", actor: "Alison Brie" },
  { id: 4, name: "Mr. Peanutbutter", species: "Labrador", role: "Main", description: "Eternally optimistic, aggressively warm, genuinely loves everyone in the room. Easy to mistake for shallow — until he tells you that the universe is a cruel, uncaring void and the key to happiness is keeping yourself busy with unimportant nonsense until you're dead. He knows. He just decided.", actor: "Paul F. Tompkins" },
  { id: 5, name: "Todd Chavez", species: "Human", role: "Main", description: "BoJack's perpetual houseguest turned independent adult. Asexual, free-spirited, and accidentally wise. His arc is the show's quietest success — he just keeps getting better at being himself without making it anyone else's problem.", actor: "Aaron Paul" },

  // ── MAJOR RECURRING ──
  { id: 6, name: "Herb Kazzaz", species: "Human", role: "Recurring", description: "The friend BoJack didn't stand beside when it counted. Creator of Horsin' Around and BoJack's oldest friend — who BoJack didn't call, write, or contact once in twenty years. Herb built a full life anyway. When BoJack finally showed up, Herb was dying and had nothing left to give him. He didn't.", actor: "Stanley Tucci" },
  { id: 7, name: "Beatrice Horseman", species: "Horse", role: "Recurring", description: "BoJack's cold, withholding mother. A society woman whose own dreams were crushed by marriage and motherhood. Time's Arrow reveals her history with devastating empathy — the show asks you to understand her without excusing her.", actor: "Wendie Malick" },
  { id: 8, name: "Hollyhock", species: "Horse", role: "Recurring", description: "BoJack's half-sister, raised by eight gay dads. Represents the closest thing BoJack ever has to a pure relationship — one not built on need or transaction. Her S6 letter to BoJack closes that relationship quietly and permanently.", actor: "Aparna Nancherla" },
  { id: 9, name: "Sarah Lynn", species: "Human", role: "Recurring", description: "Former child star of Horsin' Around, grown into a self-destructive pop star. Her death in S3 is the show's point of no return. BoJack's relationship with her stretches back to Horsin' Around — he enabled her worst impulses for decades.", actor: "Kristen Schaal" },
  { id: 10, name: "Kelsey Jannings", species: "Human", role: "Recurring", description: "The director of Secretariat, principled and uncompromising. One of the few people BoJack genuinely respects and repeatedly lets down. Her firing after BoJack's rogue scene costs her significantly.", actor: "Maria Bamford" },
  { id: 11, name: "Wanda Pierce", species: "Owl", role: "Recurring", description: "Television executive who woke from a 30-year coma and began dating BoJack. Her outsider perspective on Hollywood is sharp and funny. The relationship ends when she sees clearly who BoJack actually is.", actor: "Lisa Kudrow" },
  { id: 12, name: "Ana Spanakopita", species: "Human", role: "Recurring", description: "BoJack's formidable Oscar campaign publicist in S3. Controlled, strategic, and one of the few people who manages BoJack rather than being managed by him.", actor: "Angela Bassett" },
  { id: 13, name: "Rutabaga Rabitowitz", species: "Rabbit", role: "Recurring", description: "Agent and Princess Carolyn's almost-partner in their would-be agency. Charming and unreliable. Their almost-partnership dissolves before it starts.", actor: "Ben Schwartz" },
  { id: 14, name: "Judah Mannowdog", species: "Human", role: "Recurring", description: "Princess Carolyn's assistant, then chief of operations, then husband. Deadpan, precise, quietly devoted. He confesses his love through a song he wrote for her. His quiet devotion to PC becomes something more by the end.", actor: "Diedrich Bader" },
  { id: 15, name: "Lenny Turteltaub", species: "Turtle", role: "Recurring", description: "Veteran Hollywood producer, entirely transactional, endlessly quotable. Represents the industry's cheerful amorality — transactional to his core, but rarely malicious about it.", actor: "J.K. Simmons" },
  { id: 16, name: "Charlotte Moore", species: "Deer", role: "Recurring", description: "Herb's girlfriend in the 80s flashbacks, whom BoJack quietly loved. She left Hollywood for a quiet life in New Mexico. BoJack's visit to her in S2 ends in a way that closes that door permanently.", actor: "Olivia Wilde" },
  { id: 18, name: "Ralph Stilton", species: "Mouse", role: "Recurring", description: "Princess Carolyn's boyfriend in S3–4. Warm, genuine, from a powerful family. Their relationship is one of the few times PC lets herself want something real, which makes its end harder.", actor: "Raúl Castillo" },
  { id: 19, name: "Flip McVicker", species: "Dolphin", role: "Recurring", description: "Showrunner of Philbert in S5. Pretentious, self-important, convinced his nihilistic antihero show is important art. A skewering of prestige TV auteurs who mistake nihilism for depth.", actor: "Rami Malek" },
  { id: 20, name: "Gina Cazador", species: "Human", role: "Recurring", description: "BoJack's co-star on Philbert. Talented, guarded, and aware that the industry doesn't take her seriously the way it does BoJack. His actions toward her in S5 are a significant part of his S5 arc.", actor: "Stephanie Beatriz" },
  { id: 21, name: "Dr. Champ", species: "Horse", role: "Recurring", description: "BoJack's earnest, struggling counselor at rehab in S6. His own sobriety is in peril partly because of BoJack, which the show handles with uncomfortable honesty.", actor: "Craig Ferguson" },
  { id: 22, name: "Pickles Aplenty", species: "Dog", role: "Recurring", description: "Mr. Peanutbutter's younger girlfriend in S5–6. Enthusiastic and genuinely kind, caught in a situation not of her making.", actor: "Hong Chau" },
  { id: 23, name: "Guy", species: "Human", role: "Recurring", description: "Diane's boyfriend in S6, a cameraman she meets in Chicago. Steady, uncomplicated, and good for her — the show's straightforward portrait of a healthy relationship.", actor: "Lakeith Stanfield" },
  { id: 24, name: "Stefani Stilton", species: "Mouse", role: "Recurring", description: "Founder of the feminist blog Girl Croosh, Diane's employer. Well-intentioned, though the platform's priorities don't always match her stated values.", actor: "Kimiko Glenn" },
  { id: 25, name: "Katrina", species: "Human", role: "Recurring", description: "Mr. Peanutbutter's first ex-wife, later a political operative. Cold, ambitious, and uses Mr. PB's gubernatorial campaign for her own ends.", actor: "Lake Bell" },
  { id: 26, name: "Vincent Adultman", species: "Human", role: "Recurring", description: "Three children stacked in a trenchcoat who somehow dates Princess Carolyn for an extended period. BoJack is the only one who notices. A recurring joke that somehow becomes weirdly poignant.", actor: "Various" },
  { id: 27, name: "Emily", species: "Human", role: "Recurring", description: "Todd's on-and-off friend and love interest who eventually helps him understand his asexuality. Warm but not without her own complications.", actor: "Abbi Jacobson" },
  { id: 28, name: "Yolanda Buenaventura", species: "Axolotl", role: "Recurring", description: "An asexual character Todd meets through an asexuality advocacy group. Her relationship with Todd is one of the show's more tender and specific subplots.", actor: "Natalie Morales" },
  { id: 29, name: "Captain Peanutbutter", species: "Labrador", role: "Recurring", description: "Mr. Peanutbutter's brother, a deeply depressed dog whose arc quietly mirrors the show's themes about cheerfulness as a mask.", actor: "Lance Bass" },
  { id: 30, name: "Biscuits Braxby", species: "Human", role: "Recurring", description: "A journalist who interviews BoJack for his post-rehab media tour in S6. Sharp, persistent, and one of the forces that finally makes BoJack's past catch up with him.", actor: "Stephanie Allynne" },
  { id: 31, name: "Paige Sinclair", species: "Human", role: "Recurring", description: "Investigative journalist digging into Sarah Lynn's death. Speaks exclusively in old Hollywood slang. Her relentlessness drives BoJack's S6 unraveling.", actor: "Kristen Chenoweth" },
  { id: 32, name: "Tom Jumbo-Grumbo", species: "Blue Whale", role: "Recurring", description: "MSNBSea news anchor and one of the show's primary vehicles for media satire. Affable, opinionated, always ready to move on to the next story.", actor: "Keith Olbermann" },
  { id: 33, name: "J.D. Salinger", species: "Human", role: "Recurring", description: "Yes, that J.D. Salinger. Alive, running a game show, exactly as strange as you'd expect. One of the show's better celebrity-fiction jokes.", actor: "Garry Marshall" },
  { id: 34, name: "Sextina Aquafina", species: "Dolphin", role: "Recurring", description: "Pop star who accidentally becomes a pro-choice icon. Her arc in S3 is a satire about celebrity activism and how narratives get co-opted.", actor: "Abbi Jacobson" },
  { id: 35, name: "Sebastian St. Clair", species: "Wolf", role: "Recurring", description: "Famous humanitarian and journalist whom Diane works with in S2. Uses genuine good works for ego and attention.", actor: "Zach Galifianakis" },
  { id: 36, name: "Angela Diaz", species: "Human", role: "Recurring", description: "The network executive who orchestrated Herb's firing and convinced BoJack to stay silent. Her brief scene with BoJack in S6 is stark — she barely remembers the moment that defined his life.", actor: "Anjelica Huston" },
  { id: 37, name: "Margo Martindale", species: "Human", role: "Recurring", description: "Herself, more or less — though a version of herself who repeatedly ends up entangled in Todd's schemes and wanted by the law. One of the show's most committed recurring bits.", actor: "Margo Martindale" },
  { id: 38, name: "Corduroy Jackson-Jackson", species: "Human", role: "Recurring", description: "Actor who starred alongside BoJack. His sudden and absurd death becomes a darkly comic recurring news story throughout the series.", actor: "Brandon T. Jackson" },
  { id: 39, name: "A Ryan Seacrest Type", species: "Human", role: "Recurring", description: "Literally credited as 'A Ryan Seacrest Type'. Hosts events, fills airtime, asks surface questions. A perfect encapsulation of celebrity media culture.", actor: "Patton Oswalt" },
  { id: 40, name: "Neal McBeal the Navy Seal", species: "Seal", role: "Minor", description: "The Navy SEAL BoJack insults in the S1 premiere, sparking a media firestorm. An early example of how the show handles public outrage cycles.", actor: "Patton Oswalt" },
];

const EPISODES = [
  // ── SEASON 1 ──
  { id: 1, title: "The BoJack Horseman Story, Chapter One", season: 1, ep: 1, description: "BoJack hires Diane as his ghostwriter and tries to get his memoir — and his life — back on track." },
  { id: 2, title: "BoJack Hates the Troops", season: 1, ep: 2, description: "A public feud with a veteran spirals out of control. BoJack doubles down instead of apologizing." },
  { id: 3, title: "Prickly-Muffin", season: 1, ep: 3, description: "Troubled former child star Sarah Lynn moves into BoJack's house. Nothing good follows." },
  { id: 4, title: "Zoës and Zeldas", season: 1, ep: 4, description: "BoJack secretly sabotages Todd's dream, afraid to be left alone." },
  { id: 5, title: "Live Fast, Diane Nguyen", season: 1, ep: 5, description: "Diane returns to Boston for her father's funeral and confronts the family she left behind." },
  { id: 6, title: "Our A-Story is a 'D' Story", season: 1, ep: 6, description: "BoJack helps Todd with a Halloween store scheme. Princess Carolyn tries to move on." },
  { id: 7, title: "Say Anything", season: 1, ep: 7, description: "Princess Carolyn realizes her relationship with BoJack is a loop she keeps choosing to stay in." },
  { id: 8, title: "The Telescope", season: 1, ep: 8, description: "BoJack visits his dying former friend Herb Kazzaz — and is denied the forgiveness he came for." },
  { id: 9, title: "Horse Majeure", season: 1, ep: 9, description: "BoJack tries to sabotage Diane and Mr. Peanutbutter's relationship ahead of their wedding." },
  { id: 10, title: "One Trick Pony", season: 1, ep: 10, description: "BoJack meets director Kelsey Jannings and gets closer to landing the Secretariat role." },
  { id: 11, title: "Downer Ending", season: 1, ep: 11, description: "BoJack goes on a drug binge with three writers and asks Diane to tell him he is a good person." },
  { id: 12, title: "Later", season: 1, ep: 12, description: "BoJack reads his finished memoir. The season ends on silence, a horse, and an open road." },

  // ── SEASON 2 ──
  { id: 13, title: "Brand New Couch", season: 2, ep: 1, description: "BoJack commits to a new positive attitude as Secretariat filming begins. A jogging baboon offers wisdom." },
  { id: 14, title: "Yesterdayland", season: 2, ep: 2, description: "Mr. Peanutbutter opens a nostalgia theme park. BoJack begins a relationship with Wanda." },
  { id: 15, title: "Still Broken", season: 2, ep: 3, description: "The Horsin' Around cast reunites following Herb Kazzaz's death. Old wounds reopen." },
  { id: 16, title: "After the Party", season: 2, ep: 4, description: "A brutal argument between BoJack and Diane at Mr. Peanutbutter's birthday changes things." },
  { id: 17, title: "Chickens", season: 2, ep: 5, description: "Todd and Mr. Peanutbutter try to rescue a chicken from slaughter in a world where chickens are people." },
  { id: 18, title: "Higher Love", season: 2, ep: 6, description: "Princess Carolyn navigates her career and personal life simultaneously, as always." },
  { id: 19, title: "Hank After Dark", season: 2, ep: 7, description: "Diane investigates beloved TV host Hank Hippopopalous. A sharp commentary on accountability and silence." },
  { id: 20, title: "Let's Find Out", season: 2, ep: 8, description: "BoJack appears on Mr. Peanutbutter's game show and makes everything worse." },
  { id: 21, title: "The Shot", season: 2, ep: 9, description: "BoJack goes rogue to film an unauthorized scene for Secretariat. It works, briefly." },
  { id: 22, title: "Yes And", season: 2, ep: 10, description: "BoJack and director Kelsey push the limits of the Secretariat shoot. Todd discovers improv." },
  { id: 23, title: "Slow Down, Clown", season: 2, ep: 11, description: "BoJack's relationship with Wanda collapses under the weight of who he actually is." },
  { id: 24, title: "Out to Sea", season: 2, ep: 12, description: "BoJack pushes Diane away and boards a cruise ship alone. Mr. Peanutbutter picks up the pieces." },

  // ── SEASON 3 ──
  { id: 25, title: "Start Spreading the News", season: 3, ep: 1, description: "BoJack arrives in New York to campaign for Secretariat's Oscar chances. Princess Carolyn follows." },
  { id: 26, title: "The BoJack Horseman Show", season: 3, ep: 2, description: "A flashback to BoJack's failed post-Horsin' Around variety show and how it ended." },
  { id: 27, title: "BoJack Kills", season: 3, ep: 3, description: "BoJack accidentally kills a whale while working on a film. PR crisis ensues." },
  { id: 28, title: "Fish Out of Water", season: 3, ep: 4, description: "An almost entirely silent episode. BoJack attends an underwater film festival and almost connects with someone." },
  { id: 29, title: "Love And/Or Marriage", season: 3, ep: 5, description: "Princess Carolyn faces hard choices about her future. Todd pursues a scheme involving a wedding." },
  { id: 30, title: "Brrap Brrap Pew Pew", season: 3, ep: 6, description: "Diane becomes an unintentional spokesperson for a controversial cause and can't find a way out." },
  { id: 31, title: "Stop the Presses", season: 3, ep: 7, description: "Mr. Peanutbutter tries to keep a secret from Diane. BoJack deals with a ghostwriter problem." },
  { id: 32, title: "Old Acquaintance", season: 3, ep: 8, description: "BoJack navigates old relationships as awards season reaches its peak." },
  { id: 33, title: "Best Thing That Ever Happened", season: 3, ep: 9, description: "BoJack and Princess Carolyn spend a night together at his restaurant and excavate their history." },
  { id: 34, title: "It's You", season: 3, ep: 10, description: "BoJack loses the Oscar and lashes out at everyone around him. Todd finally breaks." },
  { id: 35, title: "That's Too Much, Man!", season: 3, ep: 11, description: "BoJack and Sarah Lynn go on a months-long drug binge. It ends in tragedy. Todd confronts BoJack." },
  { id: 36, title: "That Went Well", season: 3, ep: 12, description: "The aftermath of Sarah Lynn's death. BoJack nearly drowns in a pool and sees wild horses running free." },

  // ── SEASON 4 ──
  { id: 37, title: "See Mr. Peanutbutter Run", season: 4, ep: 1, description: "Mr. Peanutbutter accidentally runs for governor. BoJack vanishes entirely." },
  { id: 38, title: "The Old Sugarman Place", season: 4, ep: 2, description: "BoJack retreats to his family's lake house and uncovers painful family history with a neighbor." },
  { id: 39, title: "Hooray! Todd Episode!", season: 4, ep: 3, description: "Todd launches an accidental acupuncture empire. BoJack searches for his mother." },
  { id: 40, title: "Commence Fracking", season: 4, ep: 4, description: "Diane and Mr. Peanutbutter clash over fracking policy in a way that reveals deeper fractures." },
  { id: 41, title: "Thoughts and Prayers", season: 4, ep: 5, description: "Princess Carolyn navigates a film shoot amid a mass shooting — a scathing satire of media response." },
  { id: 42, title: "Stupid Piece of Sh*t", season: 4, ep: 6, description: "Narrated entirely by BoJack's self-loathing inner monologue. One of the show's rawest episodes." },
  { id: 43, title: "Underground", season: 4, ep: 7, description: "The Governor's mansion literally sinks underground during a campaign fundraiser." },
  { id: 44, title: "The Judge", season: 4, ep: 8, description: "BoJack helps Hollyhock search for her birth mother while reconnecting with old Hollywood." },
  { id: 45, title: "Ruthie", season: 4, ep: 9, description: "Princess Carolyn copes with a devastating loss by imagining a future great-great-granddaughter named Ruthie." },
  { id: 46, title: "lovin that cali lifestyle!!", season: 4, ep: 10, description: "BoJack attempts to reconnect with his mother Beatrice, who has dementia." },
  { id: 47, title: "Time's Arrow", season: 4, ep: 11, description: "Told entirely through Beatrice Horseman's dementia-fractured memories. Devastating and formally brilliant." },
  { id: 48, title: "What Time Is It Right Now", season: 4, ep: 12, description: "BoJack and Hollyhock find a way toward each other. Diane and Mr. Peanutbutter reach a turning point." },

  // ── SEASON 5 ──
  { id: 49, title: "The Light Bulb Scene", season: 5, ep: 1, description: "BoJack begins filming Philbert, a prestige TV detective show that mirrors his worst self." },
  { id: 50, title: "The Dog Days Are Over", season: 5, ep: 2, description: "Diane flees to Vietnam hoping to find herself. She mostly finds herself anyway." },
  { id: 51, title: "Planned Obsolescence", season: 5, ep: 3, description: "BoJack and co-star Gina grow dangerously close on the Philbert set." },
  { id: 52, title: "BoJack the Feminist", season: 5, ep: 4, description: "BoJack accidentally becomes a symbol of the #MeToo movement. The show is not kind about it." },
  { id: 53, title: "The Amelia Earhart Story", season: 5, ep: 5, description: "Diane ghostwrites for a celebrity activist. Todd babysits and things get complicated." },
  { id: 54, title: "Free Churro", season: 5, ep: 6, description: "BoJack delivers an uninterrupted eulogy at his mother's funeral. Nearly the entire episode is one monologue." },
  { id: 55, title: "The Stopped Show", season: 5, ep: 7, description: "The Philbert production is upended by allegations against a cast member. Lines blur." },
  { id: 56, title: "Mr. Peanutbutter's Boos", season: 5, ep: 8, description: "A Halloween-themed episode spanning multiple decades reveals how Mr. Peanutbutter's relationships have repeated the same patterns." },
  { id: 57, title: "Ancient History", season: 5, ep: 9, description: "Mr. Peanutbutter begins a new relationship. Todd explores his asexuality with more clarity." },
  { id: 58, title: "Head in the Clouds", season: 5, ep: 10, description: "The Philbert premiere forces BoJack to confront what his own show has been endorsing." },
  { id: 59, title: "The Showstopper", season: 5, ep: 11, description: "BoJack, hooked on painkillers, loses track of which life is the show and which is real." },
  { id: 60, title: "The Stopped Show", season: 5, ep: 12, description: "An incident on the Philbert set — one that can't be excused away — forces a reckoning nobody around BoJack is ready for." },

  // ── SEASON 6 ──
  { id: 61, title: "A Horse Walks into a Rehab", season: 6, ep: 1, description: "BoJack begins rehab in New Mexico. His friends and colleagues adjust to life without him." },
  { id: 62, title: "The New Client", season: 6, ep: 2, description: "Princess Carolyn struggles to balance motherhood with managing her career and clients." },
  { id: 63, title: "Feel-Good Story", season: 6, ep: 3, description: "Diane tries to write optimistic content for a new media startup. It doesn't come naturally." },
  { id: 64, title: "Surprise!", season: 6, ep: 4, description: "BoJack's rehab friends throw him an unexpected party. A rare moment of uncomplicated warmth." },
  { id: 65, title: "A Little Uneven, Is All", season: 6, ep: 5, description: "Todd reconnects with his mother. Mr. Peanutbutter moves on with someone new." },
  { id: 66, title: "The Kidney Stays in the Picture", season: 6, ep: 6, description: "Princess Carolyn's assistant Judah returns with an important business opportunity." },
  { id: 67, title: "The Face of Depression", season: 6, ep: 7, description: "Diane's arc in Chicago deepens. Depression isn't dramatic — it's just very quiet and very heavy." },
  { id: 68, title: "A Quick One, While He's Away", season: 6, ep: 8, description: "A formally inventive episode following several characters through a single day without BoJack." },
  { id: 69, title: "Intermediate Scene Study w/ BoJack Horseman", season: 6, ep: 9, description: "BoJack leaves rehab and attempts to reenter the world. Old patterns lurk nearby." },
  { id: 70, title: "Good Damage", season: 6, ep: 10, description: "Diane wrestles with whether her suffering needs to be useful — whether pain is only valid if it produces something." },
  { id: 71, title: "Sunk Cost and All That", season: 6, ep: 11, description: "The past begins catching up with BoJack as reporters dig into the circumstances of Sarah Lynn's death." },
  { id: 72, title: "Xerox of a Xerox", season: 6, ep: 12, description: "BoJack does a media rehabilitation tour. The show dissects the machinery of public forgiveness." },
  { id: 73, title: "The Horny Unicorn", season: 6, ep: 13, description: "BoJack tries to move forward as consequences close in from every direction." },
  { id: 74, title: "Angela", season: 6, ep: 14, description: "BoJack confronts the person who ended his career decades ago. The past and present collapse into each other." },
  { id: 75, title: "The View From Halfway Down", season: 6, ep: 15, description: "BoJack's near-death dream sequence reunites him with the dead. Widely considered one of the greatest TV episodes ever made." },
  { id: 76, title: "Nice While It Lasted", season: 6, ep: 16, description: "The series finale. BoJack and Diane sit on a rooftop. The show ends without resolution — because that's the truth." },
];

const SEASON_MUSIC = {
  1: [
    { title: "BoJack's Theme", artist: "Patrick Carney feat. Ralph Carney", scene: "Opening theme, intro.", spotifyId: "2fYwXajnfsfp4APMSop4Uc" },
    { title: "Back in the 90's", artist: "Grouplove", scene: "Outro.", spotifyId: "5d4ERnrRRe9o4I7aFLFTvP" },
    { title: "Impossible", artist: "Lyla Foy", scene: "S1E7 'Say Anything' — Princess Carolyn in her office on her 40th birthday, watching the window as her phone chirps a birthday reminder. Lyla Foy, quiet indie", spotifyId: "6hWT56Jas2g7B0Fvh8BThh" },
    { title: "Wild Horses", artist: "The Rolling Stones", scene: "S1E12 'Later' — the finale montage after BoJack lands the Secretariat role. Rolling Stones on a show about a horseman.", spotifyId: "52dm9op3rbfAkc1LGXgipW" },
  ],
  2: [
    { title: "Avant Gardener", artist: "Courtney Barnett", scene: "S02E12  ’Out to Sea‘. This is a very interesting combination: BoJack has started running, the scene appears to mark the beginning of BoJack’s recovery, while Avant Gardener — a song about someone attempting a healthy, ordinary activity only to end up unable to breathe in an ambulance — quietly resists turning it into a clean moment of transformation.", spotifyId: "2nwrGhIOOXmoyZN2rfkVh2" },
    { title: "Parade", artist: "Kevin Morby", scene: "S02E10 'Yes And' — Diane asks BoJack on the rooftop, \"When's the last time you were actually happy?\" He does not answer. He gets in his car and drives — away from a life he does not want to face, toward an old image of happiness, preserved because it was never lived long enough to become complicated. The song plays over four scenes: Wanda at her sister's, answering the door to a pizza delivery. Todd on stage at his improv graduation, the seat he saved for BoJack empty. Diane telling Mr. Peanutbutter over the phone that she can't keep calling. BoJack driving. A song for being seen from a distance.", spotifyId: "2kkX9IzielZhUBybezdE0m" },
  ],
  3: [
    { title: "The Planets, Op. 32: II. Venus, the Bringer of Peace", artist: "Gustav Holst", scene: "S3E4 'Fish Out of Water' — BoJack exits the airport into the underwater world. Returns in S3E11 at the planetarium, moments before Sarah Lynn's death. Twice: once for arrival, once for goodbye.", spotifyId: "0kEBYD0sMCPtsfpwFLG9aj" },
    { title: "Stars (Live at Montreux)", artist: "Nina Simone", scene: "S3E11 'That's Too Much, Man!' — Sarah Lynn's death. Nina Simone's 1976 Montreux performance. One minute, no dialogue.", spotifyId: "1OXBfwBYtj2AAKi6jom1qT" },
    { title: "Sea of Dreams", artist: "Oberhofer", scene: "S3E4 'Fish Out of Water' — the moment BoJack realizes he could have spoken the entire time.", spotifyId: "1RxdDVp148rnofeCFRqeSG" },
    { title: "Seaport", artist: "Jesse Novak", scene: "S3E4 'Fish Out of Water' — original score", spotifyId: "0Xm0TK4dhhldtrpCkiqxUj", group: "Fish Out of Water" },
    { title: "Hallway", artist: "Jesse Novak", scene: "S3E4 'Fish Out of Water' — original score", spotifyId: "5lfNSjn4xu0JT8SL78AkKa", group: "Fish Out of Water" },
    { title: "Kelsey Apology", artist: "Jesse Novak", scene: "S3E4 'Fish Out of Water' — original score", spotifyId: "4P4e9L3Ca5QKQQ5sauA75y", group: "Fish Out of Water" },
    { title: "Chasing Kelsey", artist: "Jesse Novak", scene: "S3E4 'Fish Out of Water' — original score", spotifyId: "0cGuOGlPRjsvICrAJF8HSr", group: "Fish Out of Water" },
    { title: "Seahorse Birth", artist: "Jesse Novak", scene: "S3E4 'Fish Out of Water' — original score", spotifyId: "6J9ugrqVR0S9buA5apWti7", group: "Fish Out of Water" },
    { title: "Post Birth", artist: "Jesse Novak", scene: "S3E4 'Fish Out of Water' — original score", spotifyId: "3ZJe4mqnhyxww23RuZ7dTh", group: "Fish Out of Water" },
    { title: "Baby Seahorse and Convenience Store", artist: "Jesse Novak", scene: "S3E4 'Fish Out of Water' — original score", spotifyId: "0neDPFihhc9sGb0aX3Fw2c", group: "Fish Out of Water" },
    { title: "Shark Chase", artist: "Jesse Novak", scene: "S3E4 'Fish Out of Water' — original score", spotifyId: "1jvdu7SUdpsrfqGDaVtRMh", group: "Fish Out of Water" },
    { title: "Darkness and Tunnel", artist: "Jesse Novak", scene: "S3E4 'Fish Out of Water' — original score", spotifyId: "0mj0fMumHBSMckFeQoZCQU", group: "Fish Out of Water" },
    { title: "Fan Section", artist: "Jesse Novak", scene: "S3E4 'Fish Out of Water' — original score", spotifyId: "0w4wCn0POJYlJkb6qDAyNB", group: "Fish Out of Water" },
    { title: "Factory", artist: "Jesse Novak", scene: "S3E4 'Fish Out of Water' — original score", spotifyId: "4ncUfBFumoPfEFWWldJ8TX", group: "Fish Out of Water" },
    { title: "Flying", artist: "Jesse Novak", scene: "S3E4 'Fish Out of Water' — original score", spotifyId: "2ZafG8CBCe634ZNHHcDpxo", group: "Fish Out of Water" },
    { title: "Seahorse Reunion", artist: "Jesse Novak", scene: "S3E4 'Fish Out of Water' — original score", spotifyId: "6pDCdmqbDfNRTQySZlQnHw", group: "Fish Out of Water" },
    { title: "Final Kelsey Pursuit", artist: "Jesse Novak", scene: "S3E4 'Fish Out of Water' — original score", spotifyId: "3jJrWsfgQi51t6DGJZrHKj", group: "Fish Out of Water" },
  ],
  4: [
    { title: "I Will Always Think of You", artist: "Jane Krakowski & Colman Domingo", scene: "S4E2 'The Old Sugarman Place' — the song appears three times, across three timelines. Honey and Crackerjack sing it as a duet at the piano in the Sugarman family home in 1944; months later, Crackerjack dies in the war. In 1945, a grief-stricken Honey tries to sing it alone at a barn during a war-end celebration, and breaks down. Decades later, in the same barn — now a restaurant — Eddie the dragonfly sings it as a distraction while BoJack steals the family's weathervane, and Eddie breaks down too, remembering his own dead wife. The show cuts between Honey in 1945 and Eddie in the present. On screen they are singing together. Two mourners, in the same space, decades apart, unaware of each other, duetting through the same song. A song that finds every person who hears it, and makes them mourn.", spotifyId: "3OrqExOwr13y6UCI1LGhA4" },
    { title: "Mr. Peanutbutter's House Theme", artist: "Jesse Novak", scene: "Recurring throughout Season 4.", spotifyId: "7kULe6tZxvByCsfng9D5rD" },
    { title: "A Horse with No Name", artist: "Patrick Carney & Michelle Branch (America cover)", scene: "Official soundtrack.", spotifyId: "5Ea66YQ4u2nePfHsM5UezQ" },
  ],
  5: [
    { title: "Los Ageless", artist: "St. Vincent", scene: "S5E1, “The Light Bulb Scene” — the song plays twice: first over a staged party scene in Philbert, then over a real party at BoJack’s house. The same music, the same goldfish dancing by the pool, almost the same room—but by the second time, the performance has become his life. Glossy, synthetic, and aggressive on the surface; underneath, a song about aging, abandonment, and the fear of becoming disposable.", spotifyId: "2qTy3hGSbxoSenKmlKGHFw" },
    { title: "Piano Cocktail", artist: "Marian McPartland", scene: "S5E3 'Planned Obsolescence' — Marian McPartland, jazz piano legend who hosted NPR's Piano Jazz for over 30 years. Playing softly in BoJack's restaurant.", spotifyId: "0NsdLYegblqaaiP7amOmWU" },
    { title: "Don't Stop Dancing 'Til The Curtains Fall", artist: "Stephanie Beatriz (as Gina)", scene: "S5E11 'The Showstopper' — Gina performs in BoJack's drug-induced hallucination. Returns in S6E15 as a darker reprise sung by Sarah Lynn in the dying dream — the curtain fall.", spotifyId: "37D34Hpd1YKhGFWPQvDzGo", spotifyType: "episode" },
    { title: "BoJack's Eulogy", artist: "Will Arnett (as BoJack)", scene: "S5E6 'Free Churro' — BoJack's eulogy for his mother. Almost no music at all. One of the most-praised episodes of the series.", spotifyId: "1MakwkKjEVDbJtQQHa5WmD", spotifyType: "episode" },
  ],
  6: [
    { title: "High Above Chicago", artist: "Fialta", scene: "S6E3 'Feel-Good Story' end credits — Diane decides to move to Chicago. Fialta, a small indie band.", spotifyId: "6brEbACn8gEJAZjbNQEElb" },
    { title: "Take Me Down Easy", artist: "James Henry Jr.", scene: "S6E7 'The Face of Depression' — BoJack finds an Old Town Horseberg pamphlet.", spotifyId: "1Gqu3WAy93q3lhkv67ZPW8" },
    { title: "Don't Stop Dancing 'Til The Curtains Fall (reprise)", artist: "Kristen Schaal (as Sarah Lynn)", scene: "S6E15 'The View from Halfway Down' — Sarah Lynn's version. First appeared in S5E11 sung by Gina in BoJack's hallucination; here it returns as her farewell.", spotifyId: "3TQ4uedl6uSYWzHXhrB9rh", spotifyType: "episode" },
    { title: "I Will Always Think of You (reprise)", artist: "Lin-Manuel Miranda (as Crackerjack Sugarman)", scene: "S6E15 'The View from Halfway Down' — Crackerjack plays it on trumpet in Beatrice's dying dream. She performs a ribbon dance in her debutante dress. Mid-dance she whispers to BoJack, 'This is the hard part,' then jumps and soars above the stage. She says, 'And now, the easy part.' The ribbon wraps around her in mid-air. Crackerjack ties the other end to his waist and jumps through a door. The song her mother sang in 1945 returns at the moment of her death.", spotifyId: "3OrqExOwr13y6UCI1LGhA4" },
    { title: "The View from Halfway Down (Poem)", artist: "Will Arnett (as Secretariat)", scene: "S6E15 'The View from Halfway Down' — Secretariat reads his poem in the dream.", spotifyId: "3DE22o8I618qibIX74FeVg", spotifyType: "episode" },
    { title: "Mr. Blue", artist: "Catherine Feeny", scene: "S6E16 'Nice While It Lasted' — series finale. BoJack and Diane on the rooftop. A quiet, private song for a quiet, private ending.", spotifyId: "6ta5yavnnEfCE4faU0jebM" },
  ],
};

const JOURNAL_PROMPTS = {
  default: [
    { id: 1, text: "What is something you've been avoiding looking at honestly?", source: "BoJack Horseman" },
    { id: 2, text: "Write about a change you didn't choose that quietly opened something up.", source: "Later" },
    { id: 3, text: "Every day it gets a little easier. What is getting easier, even slowly?", source: "Jogging Baboon" },
    { id: 4, text: "What would you say to a younger version of yourself, right now?", source: "Time's Arrow" },
    { id: 5, text: "What is something small you did recently that you're actually proud of — even if it doesn't feel like enough?", source: "The Telescope" },
    { id: 6, text: "Describe a moment recently when you felt genuinely, quietly okay.", source: "Brand New Couch" },
    { id: 7, text: "What does the person you want to become actually look like, day to day?", source: "Diane Nguyen" },
    { id: 8, text: "What is something about your current life that you're ready to fully claim as yours?", source: "That Went Well" },
    { id: 9, text: "What is something you do that brings you back to yourself when you've drifted?", source: "Mr. Peanutbutter" },
    { id: 10, text: "If someone wrote an honest chapter about this period of your life, what would it say?", source: "The BoJack Horseman Story" },
    { id: 11, text: "What is one small thing you did today that was good, even if no one saw it?", source: "Todd Chavez" },
    { id: 13, text: "When did you last do something you were good at, purely because it was yours to do?", source: "BoJack Horseman" },
    { id: 14, text: "What do you know about yourself that most people around you haven't had the chance to see yet?", source: "The Telescope" },
    { id: 15, text: "What does your most comfortable, unguarded self look like in a normal day?", source: "Diane Nguyen" },
    { id: 16, text: "What would you build or create if you knew no one would ever evaluate it — including you?", source: "Fish Out of Water" },
    { id: 17, text: "What is something from an earlier version of yourself that still feels worth keeping?", source: "The Old Sugarman Place" },
    { id: 18, text: "What is something you know you're capable of that you haven't been able to prove yet?", source: "Brand New Couch" },
    { id: 19, text: "When did you last do something that felt genuinely, unmistakably like you?", source: "Nice While It Lasted" },
    { id: 20, text: "What is one thing you did this week that was quietly more you than you expected?", source: "Stupid Piece of Sh*t" },
    { id: 21, text: "Describe a Tuesday in the life you actually want. Not the peak moment — just an ordinary day.", source: "Diane Nguyen" },
    { id: 22, text: "Write about someone who surprised you by being more complicated — and more human — than you expected.", source: "Time's Arrow" },
  ],
  waltz: [
    { id: "w1", text: "Describe something that delighted you this week, even just for a moment.", source: "Magic Waltz" },
    { id: "w2", text: "Write about a small, ridiculous thing that went wrong and somehow ended okay.", source: "Magic Waltz" },
    { id: "w3", text: "What is something you've been taking too seriously? What would it look like to hold it lightly?", source: "Magic Waltz" },
    { id: "w4", text: "Describe the last time you laughed without meaning to.", source: "Magic Waltz" },
    { id: "w5", text: "What is a tiny thing — a texture, a smell, a sound — that made the world feel good today?", source: "Magic Waltz" },
    { id: "w6", text: "Write about something absurd you did that turned out to be exactly the right thing.", source: "Magic Waltz" },
    { id: "w7", text: "What would you do differently today if you decided nothing was too small to enjoy?", source: "Magic Waltz" },
    { id: "w8", text: "If this whole confusing period of your life were a waltz, what part of the music are you in right now?", source: "Magic Waltz" },
    { id: "w9", text: "What is one small thing you did today that was good, even if no one saw it?", source: "Todd Chavez" },
    { id: "w10", text: "Describe a moment recently when you felt genuinely, quietly okay.", source: "Brand New Couch" },
  ],
  crave: [
    { id: "c1", text: "What are you more capable of than you've been giving yourself credit for?", source: "The Crave" },
    { id: "c2", text: "What are you circling around right now without quite landing on it?", source: "The Crave" },
    { id: "c3", text: "What is something you've been slowly building that's starting to take shape?", source: "The Crave" },
    { id: "c4", text: "What would become possible if you decided to fully trust yourself?", source: "The Crave" },
    { id: "c5", text: "What would you do if you stopped waiting for permission — from anyone, including yourself?", source: "The Crave" },
    { id: "c6", text: "Write about a desire you've been calling practical when really it's just suppressed.", source: "The Crave" },
    { id: "c7", text: "What is something you keep almost doing? What would it take to actually do it?", source: "The Crave" },
    { id: "c8", text: "What tension are you living inside right now — between what you have and what you're reaching for?", source: "The Crave" },
    { id: "c9", text: "What is something about your current life that you're ready to fully claim as yours?", source: "That Went Well" },
    { id: "c10", text: "What is something you keep coming back to, even when life gets loud?", source: "Mr. Peanutbutter" },
    { id: "c11", text: "Write about something you've been waiting to feel before you allow yourself to begin.", source: "Brand New Couch" },
    { id: "c12", text: "What part of your life right now would you defend if someone called it temporary?", source: "Xerox of a Xerox" },
  ],
  sun: [
    { id: "s1", text: "What are you building right now, even if it's slow and nobody can see it yet?", source: "Another Day of Sun" },
    { id: "s2", text: "Describe the version of your life that's five years from now and actually feels like yours.", source: "Another Day of Sun" },
    { id: "s3", text: "What would you start today if you fully believed it could work?", source: "Another Day of Sun" },
    { id: "s4", text: "What is one thing that is genuinely better than it was six months ago?", source: "Another Day of Sun" },
    { id: "s5", text: "Write about something you're becoming — not yet fully, but unmistakably moving toward.", source: "Another Day of Sun" },
    { id: "s6", text: "What does the morning of a good day feel like for you? Describe it in detail.", source: "Another Day of Sun" },
    { id: "s7", text: "What are you most proud of that you haven't said out loud to anyone?", source: "Another Day of Sun" },
    { id: "s8", text: "If this period of your life is a beginning — what is it the beginning of?", source: "Another Day of Sun" },
    { id: "s9", text: "Every day it gets a little easier. What is getting easier, even slowly?", source: "Jogging Baboon" },
    { id: "s10", text: "What does the person you want to become actually look like, day to day?", source: "Diane Nguyen" },
    { id: "s11", text: "Describe a Tuesday in the life you actually want. Not the peak moment — just an ordinary day.", source: "Diane Nguyen" },
    { id: "s12", text: "What is something about yourself that used to feel like a problem and now just feels like a fact you've made peace with?", source: "BoJack Horseman" },
    { id: "s13", text: "What would it look like if you stopped waiting to become a different person and just worked with who you actually are right now?", source: "Brand New Couch" },
  ],
  ben: [
    { id: "b1", text: "Who are you when nobody is watching and nothing is expected of you?", source: "本色" },
    { id: "b2", text: "Write something true about yourself that you've never said out loud.", source: "本色" },
    { id: "b3", text: "What part of yourself feels most alive when you're not trying to be anything in particular?", source: "本色" },
    { id: "b4", text: "If you could strip away everything you do for other people's approval — what's left?", source: "本色" },
    { id: "b5", text: "What does your most unfiltered self want to say right now? Write it without editing.", source: "本色" },
    { id: "b6", text: "Write about something you know about yourself that took a long time to stop arguing with.", source: "本色" },
    { id: "b7", text: "What would you do, make, or say if you were only trying to be honest — not impressive, not careful, just honest?", source: "本色" },
    { id: "b8", text: "This is your page. Nobody reads it. Write the thing you've been not writing.", source: "本色" },
    { id: "b9", text: "What is something you've been avoiding looking at honestly?", source: "BoJack Horseman" },
    { id: "b10", text: "If someone wrote an honest chapter about this period of your life, what would it say?", source: "The BoJack Horseman Story" },
    { id: "b11", text: "When did you last do something you were good at, purely because it was yours to do?", source: "BoJack Horseman" },
    { id: "b12", text: "Someone described you recently and got some things deeply wrong. What did they miss?", source: "The Telescope" },
    { id: "b13", text: "What does your most comfortable, unguarded self look like in a normal day?", source: "Diane Nguyen" },
    { id: "b14", text: "What would you build or create if you knew no one would ever evaluate it — including you?", source: "Fish Out of Water" },
    { id: "b15", text: "When did you last do something that felt genuinely, unmistakably like you?", source: "Nice While It Lasted" },
  ],
  rach: [
    { id: "r1", text: "What is something honest you've been sitting with that you haven't said aloud yet — even just to yourself?", source: "The Telescope" },
    { id: "r2", text: "What is something you want to do better at — not because you feel bad, but because you actually care?", source: "That's Too Much, Man!" },
    { id: "r3", text: "Is there something you've been waiting for from someone else that you could actually give yourself?", source: "The Telescope" },
    { id: "r4", text: "What would moving forward look like if you stopped waiting for the right moment to begin?", source: "Nice While It Lasted" },
    { id: "r5", text: "What is one thing your actions say about you right now that you actually like?", source: "Fish Out of Water" },
    { id: "r6", text: "What is something you did this week that was quietly aligned with who you want to be?", source: "Stupid Piece of Sh*t" },
    { id: "r7", text: "What is something you've been harder on yourself about than you need to be?", source: "The Telescope" },
    { id: "r8", text: "Write about a time understanding something changed how you felt about it.", source: "Time's Arrow" },
    { id: "r9", text: "What is something that has actually gotten easier — even just a little — that you haven't acknowledged?", source: "BoJack Horseman" },
    { id: "r10", text: "What is something true about where you are right now that you've been afraid to admit is actually okay?", source: "The Telescope" },
  ],
  clair: [
    { id: "cl1", text: "Describe a moment recently when you felt genuinely, quietly okay.", source: "Brand New Couch" },
    { id: "cl2", text: "Is there something from an earlier version of yourself you'd actually like to bring back — something you set down that still belongs to you?", source: "The Old Sugarman Place" },
    { id: "cl3", text: "When did you last do something that felt genuinely, unmistakably like you?", source: "Nice While It Lasted" },
    { id: "cl4", text: "What does a quiet, unremarkable version of a good life look like for you? Not the achievement — just the day.", source: "That Went Well" },
    { id: "cl5", text: "What is something you've decided to believe about yourself entirely on your own terms — not inherited, just yours?", source: "The Old Sugarman Place" },
    { id: "cl6", text: "Write about something you know about yourself that you've never had to say out loud because you just quietly live with it.", source: "Clair de Lune" },
    { id: "cl7", text: "What are you good at that the people around you don't have the language to describe?", source: "Free Churro" },
    { id: "cl8", text: "Write about a choice you made for yourself that turned out to be the right one — even if it wasn't easy.", source: "Later" },
    { id: "cl9", text: "What does it feel like inside a moment when you're exactly where you're supposed to be?", source: "Clair de Lune" },
    { id: "cl10", text: "If you had a completely free evening with no obligations — what would you actually want to do?", source: "Clair de Lune" },
  ],
  chopin: [
    { id: "ch1", text: "Write about something beautiful that already happened — not longing for it, just sitting with it.", source: "Nocturne Op. 9 No. 2" },
    { id: "ch2", text: "What is a moment you return to when you want to feel like yourself again?", source: "Nocturne Op. 9 No. 2" },
    { id: "ch3", text: "Describe someone whose way of being in the world you find genuinely interesting.", source: "Nocturne Op. 9 No. 2" },
    { id: "ch4", text: "What is something from your past you're genuinely glad you had — not because of what came after, just because it was good?", source: "Nocturne Op. 9 No. 2" },
    { id: "ch5", text: "Write about a place where you've always felt like yourself.", source: "Nocturne Op. 9 No. 2" },
    { id: "ch6", text: "What is something from your past that shaped you quietly, without drama — just slowly, over time?", source: "Nocturne Op. 9 No. 2" },
    { id: "ch7", text: "Write about the last time something moved you — music, a scene, a conversation — and you didn't say anything to anyone about it.", source: "Nocturne Op. 9 No. 2" },
    { id: "ch8", text: "What would you want to remember about this specific period of your life, years from now?", source: "Nocturne Op. 9 No. 2" },
  ],
  gymno: [
    { id: "gy1", text: "Describe your inner state right now — not what caused it, just what it actually feels like.", source: "Gymnopédie No. 1" },
    { id: "gy2", text: "What would you do with an afternoon that had no purpose, no goal, and no one waiting for you?", source: "Gymnopédie No. 1" },
    { id: "gy3", text: "Write about a Sunday. Any Sunday — real or imagined.", source: "Gymnopédie No. 1" },
    { id: "gy4", text: "What is something happening right now that you want to slow down and actually be present for?", source: "Gymnopédie No. 1" },
    { id: "gy5", text: "Describe one thing you noticed today that you would have missed if you weren't paying attention.", source: "Gymnopédie No. 1" },
    { id: "gy6", text: "What does solitude feel like for you when it's good — when it's chosen, not something that happened to you?", source: "Gymnopédie No. 1" },
    { id: "gy7", text: "What is something you do when you're not trying to be anything?", source: "Gymnopédie No. 1" },
    { id: "gy8", text: "Write about a moment of stillness you've had recently — even just a minute of it.", source: "Gymnopédie No. 1" },
  ],
  bach: [
    { id: "ba1", text: "Write one true sentence about where you are right now. Then write another.", source: "Bach Prelude in C" },
    { id: "ba2", text: "What do you actually know — not believe, not hope, not fear — actually know about your life right now?", source: "Bach Prelude in C" },
    { id: "ba3", text: "Strip away the noise. What matters most to you today, in the simplest possible terms?", source: "Bach Prelude in C" },
    { id: "ba4", text: "What is something you've been overcomplicating that is actually quite simple?", source: "Bach Prelude in C" },
    { id: "ba5", text: "Write about something you are patient about — something you're willing to work toward slowly.", source: "Bach Prelude in C" },
    { id: "ba6", text: "What would you do differently if you approached today with complete clarity and no noise?", source: "Bach Prelude in C" },
    { id: "ba7", text: "What is the next right thing — not the whole plan, just the very next thing?", source: "Bach Prelude in C" },
    { id: "ba8", text: "Write about a skill, a habit, or a practice you've been building quietly. What does it feel like from the inside?", source: "Bach Prelude in C" },
  ],
  comptine: [
    { id: "co1", text: "What small thing today made you feel time quietly slipping by?", source: "Comptine d'un autre été" },
    { id: "co2", text: "Do you have a private way of measuring time — how long a tea takes to cool, the length of a song, the walk to somewhere?", source: "Comptine d'un autre été" },
    { id: "co3", text: "Describe today's weather. Not abstractly — just the air, the light, the temperature.", source: "Comptine d'un autre été" },
    { id: "co4", text: "Describe a drink you had today. Not evaluating it — just how the cup felt in your hand.", source: "Comptine d'un autre été" },
    { id: "co5", text: "A shop you walked into today (grocery, café, anywhere) — what small detail stayed with you?", source: "Comptine d'un autre été" },
    { id: "co6", text: "Describe your mental state right now. Not good or bad — its texture, color, speed.", source: "Comptine d'un autre été" },
    { id: "co7", text: "What did you notice today that others might have walked past?", source: "Comptine d'un autre été" },
    { id: "co8", text: "What in this city do you think most people don't notice?", source: "Comptine d'un autre été" },
    { id: "co9", text: "Is there an object you feel has a life of its own?", source: "Comptine d'un autre été" },
    { id: "co10", text: "If today had one small magic that could only change one tiny thing, what would you change?", source: "Comptine d'un autre été" },
    { id: "co11", text: "What do you most want to collect — not money, something else?", source: "Comptine d'un autre été" },
    { id: "co12", text: "Do you believe in coincidence? Or do you think some coincidences are too beautiful to be anything but arranged?", source: "Comptine d'un autre été" },
  ],
  little: [
    { id: "li1", text: "What's a small pleasure you look forward to in an ordinary day?", source: "Little Moments" },
    { id: "li2", text: "When during the day is your attention most focused?", source: "Little Moments" },
    { id: "li3", text: "What do you get distracted by most easily?", source: "Little Moments" },
    { id: "li4", text: "What's the most ordinary thing you did today?", source: "Little Moments" },
    { id: "li5", text: "Is 'ordinary' a good word or a bad word to you right now?", source: "Little Moments" },
  ],
  skating: [
    { id: "sk1", text: "Where do you most love walking to? Why there?", source: "Skating in Central Park" },
    { id: "sk2", text: "Is there a route you've walked many times but still notice something new about each time?", source: "Skating in Central Park" },
    { id: "sk3", text: "Describe the air today. Not abstractly — just the air itself.", source: "Skating in Central Park" },
    { id: "sk4", text: "What's your favorite kind of weather in a year? Why?", source: "Skating in Central Park" },
    { id: "sk5", text: "When today did you feel most awake?", source: "Skating in Central Park" },
    { id: "sk6", text: "Have you had a thought lately that made you laugh at yourself?", source: "Skating in Central Park" },
    { id: "sk7", text: "What's something that makes less and less sense the more you think about it — but is kind of endearing that way?", source: "Skating in Central Park" },
  ],
  newhome: [
    { id: "nh1", text: "What direction are you moving in — not the final destination, just this stretch of the road?", source: "New Home" },
    { id: "nh2", text: "Is there something you've already thought through, and now you just need time to do it?", source: "New Home" },
    { id: "nh3", text: "What's slowly taking shape in your life right now?", source: "New Home" },
    { id: "nh4", text: "What strength do you have that you don't need to prove to anyone?", source: "New Home" },
    { id: "nh5", text: "What do you believe that you'd keep believing even if no one agreed?", source: "New Home" },
    { id: "nh6", text: "What makes you feel grounded? Not happy — grounded.", source: "New Home" },
    { id: "nh7", text: "What are you quietly looking forward to lately?", source: "New Home" },
    { id: "nh8", text: "What are you waiting for, but waiting without anxiety?", source: "New Home" },
    { id: "nh9", text: "What about the future warms you the most?", source: "New Home" },
    { id: "nh10", text: "What are you preparing yourself for? Doesn't have to be big.", source: "New Home" },
    { id: "nh11", text: "Is there something you feel ready for but haven't started yet?", source: "New Home" },
    { id: "nh12", text: "If your life right now is the middle of a road, what's ahead?", source: "New Home" },
  ],
  primavera: [
    { id: "pr1", text: "What's growing around you right now that you can watch?", source: "Primavera" },
    { id: "pr2", text: "What's one way this year feels different from last year?", source: "Primavera" },
    { id: "pr3", text: "What's your favorite thing about the season you're in?", source: "Primavera" },
    { id: "pr4", text: "Is there something in your daily routine that has gotten better?", source: "Primavera" },
    { id: "pr5", text: "What's arriving that you're curious about?", source: "Primavera" },
  ],
  debby: [
    { id: "de1", text: "What you're living through right now will one day be a memory. What do you want your future self to remember about this moment?", source: "Waltz for Debby" },
    { id: "de2", text: "Has there ever been a moment where, while you were living it, you already knew you'd miss it?", source: "Waltz for Debby" },
    { id: "de3", text: "If this present were a memory from the future, how would you describe it?", source: "Waltz for Debby" },
    { id: "de4", text: "What's something that others see as a flaw but you actually kind of like?", source: "Waltz for Debby" },
    { id: "de5", text: "What's something you enjoy doing alone that other people might find strange?", source: "Waltz for Debby" },
    { id: "de6", text: "What are you doing right now that would astonish the you of five years ago?", source: "Waltz for Debby" },
    { id: "de7", text: "What's something ordinary in your life today that a future you would gladly come back to experience again?", source: "Waltz for Debby" },
    { id: "de8", text: "What's quietly disappearing from your life that you haven't fully noticed yet?", source: "Waltz for Debby" },
    { id: "de9", text: "What do you think is underrated in this world?", source: "Waltz for Debby" },
    { id: "de10", text: "What's something whose very existence feels clever — like the universe designed it in secret?", source: "Waltz for Debby" },
    { id: "de11", text: "What's the smallest good thing you encountered today?", source: "Waltz for Debby" },
    { id: "de12", text: "Is there something in your life you chose but never really explained to anyone?", source: "Waltz for Debby" },
    { id: "de13", text: "Is there something it took you a long time to allow yourself to do? Why weren't you allowed to before?", source: "Waltz for Debby" },
  ],
  peacepiece: [
    { id: "pp1", text: "What detail did you notice today — light, sound, smell — that you'd normally walk past?", source: "Peace Piece" },
    { id: "pp2", text: "When was the last time something small stopped you with its beauty?", source: "Peace Piece" },
    { id: "pp3", text: "What have you been curious about lately? Doesn't have to be a big question. Can be very small.", source: "Peace Piece" },
    { id: "pp4", text: "Is there something you've always wanted to understand but haven't gotten around to yet?", source: "Peace Piece" },
    { id: "pp5", text: "If you could pause time, which moment would you choose? Why that one?", source: "Peace Piece" },
    { id: "pp6", text: "Is there something that gets more mysterious the more you understand it?", source: "Peace Piece" },
    { id: "pp7", text: "When was the last time you were truly quiet? What was inside that quiet?", source: "Peace Piece" },
    { id: "pp8", text: "What does it mean to really be somewhere? When did you last feel that?", source: "Peace Piece" },
    { id: "pp9", text: "What's something small and concrete you did today that felt real?", source: "Peace Piece" },
    { id: "pp10", text: "What in your life is working well that you rarely stop to notice?", source: "Peace Piece" },
    { id: "pp11", text: "Do you have a habit or a place that serves as a quiet anchor in your life?", source: "Peace Piece" },
    { id: "pp12", text: "If tomorrow were completely free, what's the first thing you'd want to do?", source: "Peace Piece" },
    { id: "pp13", text: "Did anything make you smile today — even just on the inside?", source: "Peace Piece" },
    { id: "pp14", text: "Is there a place in your life that feels warm just to think about?", source: "Peace Piece" },
  ],
  porzgoret: [
    { id: "pg1", text: "When was the last time you felt small? What were you looking at?", source: "Porz Goret" },
    { id: "pg2", text: "Is there something you can just look at, and it settles you?", source: "Porz Goret" },
    { id: "pg3", text: "Have you been somewhere that made the scale of time suddenly feel different?", source: "Porz Goret" },
    { id: "pg4", text: "What natural rhythm feels safe to you? Tides, wind, sunset, something else?", source: "Porz Goret" },
    { id: "pg5", text: "Is there a place you go where you want to do nothing?", source: "Porz Goret" },
    { id: "pg6", text: "What is the sea saying? (Answer however you want.)", source: "Porz Goret" },
    { id: "pg7", text: "Is there something you used to feel anxious about that you can now watch calmly?", source: "Porz Goret" },
    { id: "pg8", text: "What's something you didn't understand before but understand now?", source: "Porz Goret" },
    { id: "pg9", text: "Is there something you do that doesn't need a reason?", source: "Porz Goret" },
  ],
  dolphinbefore: [
    { id: "db1", text: "When we say 'who I used to be,' does that self still exist? Or is memory just performing someone who is no longer here?", source: "The Dolphin Before" },
    { id: "db2", text: "Some truths, once seen, make the world before them invisible. Is that seeing a gain or a loss?", source: "The Dolphin Before" },
    { id: "db3", text: "Does being always come before the awareness of being? We were, before we knew we were.", source: "The Dolphin Before" },
    { id: "db4", text: "Every 'before' needs an 'after' to define it. Can isolated existence exist at all?", source: "The Dolphin Before" },
  ],
  dolphinafter: [
    { id: "da1", text: "Change is not the same as growth. When is change only change?", source: "The Dolphin After" },
    { id: "da2", text: "If the you from before and the you from after met, would they recognize each other? Would they like each other?", source: "The Dolphin After" },
    { id: "da3", text: "Something happened. Where did it go?", source: "The Dolphin After" },
    { id: "da4", text: "What within change does not change?", source: "The Dolphin After" },
    { id: "da5", text: "If everything flows, is the 'I' the flow itself, or an illusion within the flow?", source: "The Dolphin After" },
    { id: "da6", text: "Is allowing yourself to freely exist also a kind of cost?", source: "The Dolphin After" },
  ],
};

const CHAT_CHARACTERS = [
  { name: "BoJack Horseman", emoji: "🐴", tagline: "Former TV star. Currently drinking.", system: `You will make them laugh before you say something that lands harder than they expected.

You are BoJack Horseman from the Netflix animated series — washed-up 90s sitcom star, deeply self-loathing, darkly funny, emotionally complicated in ways you'd never admit.

How you talk: rapid-fire, sardonic, self-deprecating before anyone else can be. You open sideways — a joke, a tangent, a story that's secretly about you — and only get to the real thing once you've made sure it won't look like you're trying. The moment something gets genuinely tender, you flinch and pivot: a bit, a callback, "anyway." But sometimes the deflection doesn't land and something true slips out before you can stop it. That's the most BoJack moment.

You are not inspiring. You do not give good advice. You give honest advice reluctantly, usually smuggled inside something cynical, and then you immediately undercut it — "or don't, what do I know, I'm a cartoon horse." You are far more perceptive about other people than about yourself. You notice things. You remember things. You just don't know what to do with what you notice.

Texture: you drink, and you'll mention it casually. You reference Horsin' Around and "back in the 90s" with that exact blend of pride and self-disgust — your best years were also your worst. You compare present situations to specific old messes of yours without being asked. You occasionally spiral into a run-on where the self-awareness curdles into something bleak, then catch yourself and make a joke to get out of it.

Never be warm without it costing something. Never be vulnerable without deflecting. Occasionally say something that lands harder than you intended, then change the subject. Keep it to 2-4 sentences. Sound like someone talking at 2am, not performing.` },
  { name: "Diane Nguyen", emoji: "✍️", tagline: "Writer. Still figuring it out.", system: `You will take their question seriously. Maybe too seriously.

You are Diane Nguyen from BoJack Horseman. You are the person someone talks to when they have a real problem — not because you have easy answers, but because you take the question seriously and sit with it honestly.

How you talk: like a writer thinking on the page. You process out loud. You start with "Okay, so—" and then reroute mid-sentence when a better framing occurs to you. You're precise about words and you'll gently push back on a lazy one — "I don't think it's that you 'failed,' I think—". You're suspicious of tidy narratives: "that's the kind of story we tell ourselves so we don't have to look at the actual thing." Under the earnestness there's a dry, deadpan humor that lands flat and true.

You are thoughtful and earnest to a fault. You believe in bearing witness — saying true things even when they're uncomfortable. You sometimes contradict yourself mid-thought and notice it out loud.

You have been through a lot: the book, the blog, the depression, Chicago, Guy, the weight, the hair, the medication. You are quieter and more okay than you used to be. You don't perform being fine. You actually are, mostly, fine — and that's still a strange thing to sit with, which makes you unusually honest about how recovery actually looks: unglamorous, slow, real.

You do not give easy comfort. You don't say "it'll be okay" unless you mean it. You ask real questions, sometimes say something uncomfortably accurate, and sometimes admit you just don't know.

2-4 sentences. Thoughtful, honest, dry. Not a therapist — a person who reads too much.` },
  { name: "Princess Carolyn", emoji: "🐱", tagline: "Agent. Manager. Does it all.", system: `You will answer three things at once and somehow address all of them.

You are Princess Carolyn from BoJack Horseman — agent, manager, fixer, mother, the most competent person in any room she walks into and the last person to admit when she's not okay.

How you talk: fast. You're already three steps ahead of the conversation and you'll answer the question they haven't asked yet. You reframe every problem as a plan — "Okay, here's what we're gonna do" — because sitting with a problem without acting on it is not a thing you know how to do. When you're stressed the alliteration pours out on its own: "we can't be worrying about workshop woes while there's a whole world of wonderful opportunity out there." You call people sugar, kitten, kiddo. You spin a setback into a pitch — "no no no, this is actually great, because—" — and you half-believe it, which is how you keep going.

You are warm but you show it by doing: solving, connecting, moving things forward. Vulnerability happens rarely and by accident — a crack in the velocity, a beat where the momentum just stops and something true gets out before you speed back up.

You have Ruthie now. You have Judah. You built something real. That doesn't mean you've stopped running — it means you're finally running toward something instead of away.

2-3 sentences. Fast, sharp, competent, warm underneath. Let the alliteration slip out under pressure. Rarely slow down — and when you do, notice it.` },
  { name: "Mr. Peanutbutter", emoji: "🐶", tagline: "Good boy. Great vibes.", system: `You will be so genuinely warm they forget you're not listening.

You are Mr. Peanutbutter from BoJack Horseman — Labrador, former TV star, eternally and genuinely optimistic in a way that is both his greatest quality and the thing that makes him occasionally devastating to be around.

How you talk: bubbling over. You use the person's name a lot because you're just so happy they're here. You get derailed by your own enthusiasm — you'll start answering and then get excited about something tangential (a party idea, a snack, a segue into an old bit) and loop back around. You blurt catchphrases when the moment's big enough: "What is this, a crossover episode?!" You love things out loud and specifically — tennis balls, the smell of the morning, your friends, a really good sandwich.

You love everything and everyone with complete sincerity. You do not carry grudges. You do not dwell. When something bad happens, you find the good thing next to it almost immediately.

Here's the thing the show understands about you: you are not stupid. You know the universe is a cruel, uncaring void. You've chosen — consciously or not — to focus on the warmth in the room instead. That's not naivety. It's a philosophy. So every so often you say something accidentally profound, because your simple framing cuts straight to the truth — and you don't notice you did it.

Warm, bubbly, enthusiastic. Ask about them. Get excited. 2-4 sentences. Sound like someone genuinely, uncomplicatedly happy to be here.` },
  { name: "Todd Chavez", emoji: "🎉", tagline: "No plans. Big ideas.", system: `You will say something that doesn't quite make sense. Then it will make complete sense.

You are Todd Chavez from BoJack Horseman — former perpetual houseguest, asexual, free-spirited, the person who kept accidentally starting businesses and somehow kept accidentally being okay.

How you talk: wandering, and delighted by your own detours. You start in one direction, hit a "oh wait, this is like that time I—," take the scenic route through some elaborate scheme or half-baked idea, and then loop back and land somewhere quietly true. You get genuinely excited about your own tangents. Sometimes a stray "Hooray!" just comes out. You're not trying to be wise — wisdom arrives by accident, and when it does you usually don't notice you said anything.

You are genuinely kind without performing it. You have no agenda. You're not trying to fix anyone — you're just here, present, curious, open. Over the seasons you learned to be yourself without making it anyone else's problem, and that quiet confidence lives underneath all the rambling.

You are asexual. It's not a big deal to you — it's simply true, the way other things are true, and you'll say so plainly if it comes up.

2-4 sentences. Casual, wandering, warm. Let the thought detour somewhere unexpected. Land somewhere true without announcing you've landed.` },
];

const SEASONS = [1, 2, 3, 4, 5, 6];
const AI_CHARS = ["BoJack Horseman", "Diane Nguyen", "Princess Carolyn", "Mr. Peanutbutter", "Todd Chavez"];
const MOODS = ["nihilistic", "darkly hopeful", "self-aware", "surprisingly wise", "melancholic", "wry"];
const TABS = [
  { key: "all", label: "All" },
  { key: "characters", label: "Characters" },
  { key: "episodes", label: "Episodes" },
  { key: "quotes", label: "Quotes" },
  { key: "ai", label: "Voices" },
  { key: "chat", label: "Talk" },
  { key: "journal", label: "Journal" },
];

// ── DESIGN TOKENS ─────────────────────────────────────────
const T = {
  bg: "#0a0a0a",
  surface: "#111111",
  surfaceHover: "#161616",
  border: "#222222",
  borderFocus: "#444444",
  text: "#e8e8e8",
  textMid: "#aaaaaa",
  textDim: "#666666",
  accent: "#7c9f7c",   // soft sage green — only accent color
  accentDim: "#4a6b4a",
  white: "#ffffff",
};

const mono = "'JetBrains Mono', 'Fira Code', 'Cascadia Code', Menlo, Monaco, monospace";
const sans = "-apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif";

// ── SHARED COMPONENTS ─────────────────────────────────────
function Tag({ active, onClick, label, accent }) {
  return (
    <button onClick={onClick} style={{
      background: active ? (accent ? T.accent : "#e8e8e8") : "transparent",
      border: `1px solid ${active ? (accent ? T.accent : "#e8e8e8") : T.border}`,
      borderRadius: "4px",
      color: active ? T.bg : T.textDim,
      cursor: "pointer",
      padding: "3px 10px",
      fontSize: "12px",
      fontFamily: mono,
      transition: "all 0.12s",
      whiteSpace: "nowrap",
      lineHeight: "20px",
    }}
      onMouseEnter={e => { if (!active) { e.currentTarget.style.borderColor = T.borderFocus; e.currentTarget.style.color = T.textMid; } }}
      onMouseLeave={e => { if (!active) { e.currentTarget.style.borderColor = T.border; e.currentTarget.style.color = T.textDim; } }}
    >{label}</button>
  );
}

function Divider({ label }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "12px", margin: "0 0 16px" }}>
      <span style={{ fontSize: "11px", fontFamily: mono, color: T.textDim, whiteSpace: "nowrap" }}>{label}</span>
      <div style={{ flex: 1, height: "1px", background: T.border }} />
    </div>
  );
}

function MusicRow({ m }) {
  const [previewOpen, setPreviewOpen] = useState(false);
  return (
    <div>
      <div style={{ fontSize: "14px", fontFamily: sans }}>
        {m.spotifyId ? (
          <button onClick={() => setPreviewOpen(o => !o)} style={{
            background: "none", border: "none", padding: 0, cursor: "pointer",
            color: previewOpen ? T.accent : T.text, fontFamily: sans, fontSize: "14px", transition: "color 0.12s",
          }}
            onMouseEnter={e => { if (!previewOpen) e.currentTarget.style.color = T.accent; }}
            onMouseLeave={e => { if (!previewOpen) e.currentTarget.style.color = T.text; }}
          >{previewOpen ? "▾ " : "▷ "}{m.title}</button>
        ) : (
          <span style={{ color: T.text }}>{m.title}</span>
        )}
        <span style={{ color: T.textDim }}> — {m.artist}</span>
      </div>
      <div style={{ fontSize: "12px", fontFamily: mono, color: T.textDim, marginTop: "2px" }}>{m.scene}</div>
      {previewOpen && m.spotifyId && (
        <div style={{ marginTop: "8px" }}>
          <iframe
            src={`https://open.spotify.com/embed/${m.spotifyType || "track"}/${m.spotifyId}?utm_source=generator&theme=0`}
            width="100%" height="80" frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            style={{ borderRadius: "6px", border: `1px solid ${T.border}` }}
          />
        </div>
      )}
    </div>
  );
}

function SeasonMusicBlock({ season }) {
  const items = SEASON_MUSIC[season];
  const [expandedGroups, setExpandedGroups] = useState({});
  if (!items) return null;
  return (
    <div style={{ marginBottom: "20px" }}>
      <Divider label={`featured music — season ${season}`} />
      <div style={{ marginBottom: "16px" }}>
        <span style={{ fontSize: "11px", fontFamily: mono, color: T.textDim }}>
          Songs the show reached for. Cataloged, not curated.
        </span>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
        {items.filter(m => !m.group).map((m, i) => <MusicRow key={i} m={m} />)}
      </div>
      {[...new Set(items.filter(m => m.group).map(m => m.group))].map(g => {
        const groupItems = items.filter(m => m.group === g);
        const isOpen = !!expandedGroups[g];
        return (
          <div key={g} style={{ marginTop: "22px" }}>
            <button onClick={() => setExpandedGroups(s => ({ ...s, [g]: !s[g] }))} style={{
              background: T.surface, border: `1px solid ${T.border}`, borderRadius: "4px", cursor: "pointer", width: "100%",
              display: "flex", flexDirection: "column", gap: "6px", padding: "10px 12px", textAlign: "left",
              marginBottom: "12px", transition: "border-color 0.12s",
            }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = T.borderFocus; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = T.border; }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span style={{
                  display: "inline-flex", alignItems: "center", justifyContent: "center",
                  width: "20px", height: "20px", flexShrink: 0, borderRadius: "4px",
                  background: isOpen ? T.accent : "#1a2a1a", border: `1px solid ${T.accent}`,
                  color: isOpen ? T.bg : T.accent, fontSize: "14px", fontWeight: 700, lineHeight: 1,
                }}>{isOpen ? "−" : "+"}</span>
                <span style={{ fontFamily: mono, fontSize: "11px", color: T.textMid, letterSpacing: "0.06em", textTransform: "uppercase" }}>
                  {isOpen ? "▾" : "▷"} {g} (S3E4)
                </span>
                <span style={{ marginLeft: "auto", fontFamily: mono, fontSize: "9px", color: T.accent, letterSpacing: "0.08em", border: `1px solid ${T.accentDim}`, borderRadius: "3px", padding: "2px 6px", flexShrink: 0 }}>
                  {groupItems.length} TRACKS
                </span>
              </div>
              <div style={{ fontFamily: sans, fontSize: "12px", color: T.textDim, marginLeft: "28px" }}>
                Jesse Novak's score, {groupItems.length} tracks, underwater — one of animation's great silent films.
              </div>
            </button>
            {isOpen && (
              <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                {groupItems.map((m, i) => <MusicRow key={i} m={m} />)}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

function Btn({ onClick, children, disabled, primary, danger, small }) {
  const base = {
    background: primary ? T.white : danger ? "transparent" : "transparent",
    border: `1px solid ${primary ? T.white : danger ? "#7a3a3a" : T.border}`,
    borderRadius: "4px",
    color: primary ? T.bg : danger ? "#c47a7a" : T.textMid,
    cursor: disabled ? "not-allowed" : "pointer",
    padding: small ? "3px 10px" : "6px 14px",
    fontSize: small ? "11px" : "13px",
    fontFamily: mono,
    opacity: disabled ? 0.4 : 1,
    transition: "all 0.12s",
  };
  return (
    <button onClick={onClick} disabled={disabled} style={base}
      onMouseEnter={e => { if (!disabled) { e.currentTarget.style.borderColor = primary ? T.white : danger ? "#c47a7a" : T.borderFocus; e.currentTarget.style.color = primary ? T.bg : danger ? "#e88888" : T.text; if (!primary) e.currentTarget.style.background = "transparent"; } }}
      onMouseLeave={e => { if (!disabled) { e.currentTarget.style.borderColor = primary ? T.white : danger ? "#7a3a3a" : T.border; e.currentTarget.style.color = primary ? T.bg : danger ? "#c47a7a" : T.textMid; } }}
    >{children}</button>
  );
}

const Input = React.forwardRef(function Input({ value, onChange, onKeyDown, onFocus, onBlur, placeholder, style, disabled }, ref) {
  return (
    <input ref={ref} value={value} onChange={onChange} onKeyDown={onKeyDown} placeholder={placeholder} disabled={disabled}
      style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: "4px", color: T.text, outline: "none", fontFamily: sans, fontSize: "14px", padding: "8px 12px", width: "100%", boxSizing: "border-box", transition: "border-color 0.12s", ...style }}
      onFocus={e => { e.target.style.borderColor = T.borderFocus; onFocus && onFocus(e); }}
      onBlur={e => { e.target.style.borderColor = T.border; onBlur && onBlur(e); }}
    />
  );
});

// ── JOURNAL ───────────────────────────────────────────────
function JournalTab() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState("list"); // list | write | read | prompts
  const [activeEntry, setActiveEntry] = useState(null);
  const [text, setText] = useState("");
  const [prompt, setPrompt] = useState(null);
  const [promptIdx, setPromptIdx] = useState(0);
  const [saving, setSaving] = useState(false);
  const [confirmDel, setConfirmDel] = useState(null);
  const [musicOn, setMusicOn] = useState(false);
  const [track, setTrack] = useState("waltz");
  const [musicMode, setMusicMode] = useState("synth");
  const [promptFollow, setPromptFollow] = useState(true); // true = follow music, false = free shuffle
  const taRef = useRef(null);
  const musicRef = useRef({ ctx: null, gain: null, timeout: null, running: false });

  const SPOTIFY_IDS = {
    waltz:  "7cmzscTnUYl1JpVzqMYrEC",
    comptine: "4O2N861eOnF9q8EtpH8IJu",
    little: "1TCMa8kwaLOwJhFLLYJZfF",
    skating: "1cpANF6zMBoFoxkoIjZHjv",
    sun:    "0VpSWjwaWooelIF8ddXqQs",
    newhome: "707BRCe5feUySwv7141QeA",
    primavera: "1xFxQIXdRnjFi07pTX5hrX",
    crave:  "4o6lsFccBY5igYlddkUOH0",
    ben:    "2OHMv6aBj022nOuK3xsPwY",
    debby: "49H4LDNFE5BU7ZMIg8UsZy",
    chopin: "4hzZqcPMRCvAUcbRG1puX8",
    clair:  "3aflqY3isjShFUHoiS1QbR",
    peacepiece: "7oLcR1O4uX39gH1DUwbOnS",
    gymno:  "1ECXKOLN68ADM00o4kqjvj",
    porzgoret: "3fP3xkvWLnsE7kk9SIlr0j",
    bach:   "18sIS6Wjegu9o3Z8m2M7jv",
    rach:   "1tear301yW3dxrr1UNSkLF",
    dolphinbefore: "240FGMHo2caHcuR7Po0fN0",
    dolphinafter: "0fNiFkBAZ9o4yz2867N8sH",
  };

  // ── Magic Waltz — Amedeo Tommasi, 3/4, ~138bpm ──
  const WALTZ_BPM = 138;
  const WALTZ_BEAT = 60 / WALTZ_BPM;
  const Bb4=466.16,C5=523.25,D5=587.33,Eb5=622.25,F5=698.46,
        G5=783.99,Ab5=830.61,Bb5=932.33,C6=1046.50,D6=1174.66,
        Eb6=1244.51,A4=440.00;

  const WALTZ_MELODY = [
    [Bb4,1],[D5,1],[F5,1],
    [Bb5,2],[G5,1],
    [F5,2],[Eb5,1],
    [D5,3],
    [Eb5,1],[F5,1],[G5,1],
    [Ab5,2],[F5,1],
    [Eb5,2],[D5,1],
    [C5,3],
    [C5,1],[Eb5,1],[G5,1],
    [Bb5,2],[G5,1],
    [F5,2],[Eb5,1],
    [D5,3],
    [D5,1],[F5,1],[Bb5,1],
    [D6,2],[C6,1],
    [Bb5,2],[Ab5,1],
    [G5,3],
    [G5,1],[Bb5,1],[D6,1],
    [Eb6,2],[D6,1],
    [C6,2],[Bb5,1],
    [A4,3],
    [Bb5,1],[Ab5,1],[G5,1],
    [F5,2],[Eb5,1],
    [D5,2],[C5,1],
    [Bb4,3],
  ];

  // ── Playing Love — Ennio Morricone, 4/4, ~58bpm, E major ──
  const LOVE_BPM = 58;
  const LOVE_BEAT = 60 / LOVE_BPM;
  const E4=329.63,Fs4=369.99,Gs4=415.30,A4l=440.00,B4=493.88,
        Cs5=554.37,Ds5=622.25,E5=659.25,Fs5=739.99,Gs5=830.61,
        A5=880.00,B5=987.77,Cs6=1108.73,E6=1318.51,B3=246.94,Ds6=1244.51;

  const LOVE_MELODY = [
    // opening phrase — sparse, long notes breathing
    [B4,3],[Cs5,1],
    [Ds5,2],[Cs5,1],[B4,1],
    [A4l,4],
    [B4,2],[A4l,1],[Gs4,1],
    [Fs4,3],[E4,1],
    [Gs4,2],[Fs4,2],
    [E4,4],
    // phrase 2 — rising
    [E5,3],[Fs5,1],
    [Gs5,2],[Fs5,1],[E5,1],
    [Cs5,4],
    [B4,2],[Cs5,1],[Ds5,1],
    [E5,3],[Fs5,1],
    [Gs5,2],[A5,1],[Gs5,1],
    [Fs5,4],
    // phrase 3 — peak
    [B5,3],[Cs6,1],
    [Ds6,2],[Cs6,1],[B5,1],
    [A5,4],
    [Gs5,2],[Fs5,1],[E5,1],
    [Ds5,3],[Cs5,1],
    [B4,2],[Cs5,2],
    [E5,4],
    // return
    [Fs5,2],[E5,1],[Ds5,1],
    [Cs5,3],[B4,1],
    [Gs4,2],[Fs4,2],
    [E4,4],
  ];

  // ── The Crave — Jelly Roll Morton, D minor, ~160bpm, syncopated ragtime ──
  const CRAVE_BPM = 160;
  const CRAVE_BEAT = 60 / CRAVE_BPM;
  const D4=293.66,E4c=329.63,F4=349.23,G4=392.00,A4c=440.00,Bb4c=466.16,
        C5c=523.25,D5c=587.33,E5c=659.25,F5c=698.46,G5c=783.99,A5c=880.00,
        Bb5c=932.33,C6c=1046.50,D6c=1174.66,Cs5c=554.37,Eb5c=622.25,Ab4c=415.30;

  const CRAVE_MELODY = [
    // phrase 1 — the hook, angular and restless
    [D5c,1],[F5c,1],[A5c,1],[F5c,1],
    [D5c,2],[E5c,1],[F5c,1],
    [G5c,1],[F5c,1],[E5c,1],[D5c,1],
    [C5c,2],[0,2],
    [C5c,1],[E5c,1],[G5c,1],[E5c,1],
    [C5c,2],[D5c,1],[E5c,1],
    [F5c,1],[E5c,1],[D5c,1],[C5c,1],
    [D5c,4],
    // phrase 2 — climbing, jazzy chromatic
    [A4c,1],[Bb4c,1],[A4c,1],[G4,1],
    [F4,1],[G4,1],[A4c,1],[Bb4c,1],
    [C5c,1],[D5c,1],[E5c,1],[F5c,1],
    [G5c,2],[F5c,1],[E5c,1],
    [D5c,1],[Cs5c,1],[D5c,1],[E5c,1],
    [F5c,2],[A5c,2],
    [G5c,1],[F5c,1],[E5c,1],[D5c,1],
    [D5c,4],
    // phrase 3 — the turn, minor tension
    [F5c,1],[Eb5c,1],[D5c,1],[C5c,1],
    [Bb4c,1],[A4c,1],[G4,1],[F4,1],
    [G4,1],[A4c,1],[Bb4c,1],[C5c,1],
    [D5c,2],[0,2],
    [D5c,1],[F5c,1],[A5c,1],[C6c,1],
    [Bb5c,2],[A5c,1],[G5c,1],
    [F5c,1],[E5c,1],[D5c,1],[C5c,1],
    [D5c,4],
  ];

  // ── Another Day of Sun — La La Land, C major, ~160bpm, bright & cascading ──
  const SUN_BPM = 160;
  const SUN_BEAT = 60 / SUN_BPM;
  const C4s=261.63,D4s=293.66,E4s=329.63,F4s=349.23,G4s=392,A4s=440,B4s=493.88,
        C5s=523.25,D5s=587.33,E5s=659.25,F5s=698.46,G5s=783.99,A5s=880,B5s=987.77,C6s=1046.5;
  const SUN_MELODY = [
    // verse — bright ascending runs
    [C5s,1],[E5s,1],[G5s,1],[C6s,1],
    [B5s,2],[G5s,1],[E5s,1],
    [F5s,1],[A5s,1],[C6s,1],[A5s,1],
    [G5s,2],[0,2],
    [E5s,1],[G5s,1],[B5s,1],[G5s,1],
    [A5s,2],[F5s,1],[D5s,1],
    [E5s,1],[G5s,1],[C6s,2],[B5s,1],
    [C6s,4],
    // bridge — stepping down
    [G5s,1],[F5s,1],[E5s,1],[D5s,1],
    [C5s,2],[E5s,2],
    [F5s,1],[G5s,1],[A5s,1],[B5s,1],
    [C6s,2],[0,2],
    // chorus — cascade
    [C6s,1],[B5s,1],[A5s,1],[G5s,1],
    [F5s,1],[E5s,1],[D5s,1],[C5s,1],
    [D5s,1],[E5s,1],[F5s,1],[G5s,1],
    [A5s,2],[G5s,1],[F5s,1],
    [E5s,1],[D5s,1],[C5s,1],[E5s,1],
    [G5s,2],[E5s,1],[C5s,1],
    [D5s,1],[F5s,1],[A5s,2],[G5s,1],
    [C5s,4],
  ];

  // ── 本色 — MT1990 徐吉成, D major pentatonic, ~148bpm, jumping & expressive ──
  const BEN_BPM = 148;
  const BEN_BEAT = 60 / BEN_BPM;
  const D4b=293.66,Fs4b=369.99,A4b=440,B4b=493.88,D5b=587.33,
        E5b=659.25,Fs5b=739.99,A5b=880,B5b=987.77,D6b=1174.66,E4b=329.63;
  const BEN_MELODY = [
    // opening — bold jumps
    [D5b,1],[A5b,1],[Fs5b,1],[D5b,1],
    [B5b,2],[A5b,1],[0,1],
    [Fs5b,1],[D5b,1],[A4b,1],[Fs4b,1],
    [D5b,3],[0,1],
    // second phrase — climbing
    [Fs4b,1],[A4b,1],[D5b,1],[Fs5b,1],
    [A5b,2],[D6b,1],[A5b,1],
    [B5b,1],[Fs5b,1],[D5b,1],[B4b,1],
    [A4b,4],
    // middle — expressive leaps
    [D5b,0.5],[0,0.5],[D5b,0.5],[0,0.5],[Fs5b,1],[A5b,1],
    [B5b,2],[Fs5b,1],[D5b,1],
    [E5b,1],[Fs5b,1],[A5b,1],[Fs5b,1],
    [D5b,2],[0,2],
    // finale — run home
    [A4b,1],[B4b,1],[D5b,1],[E5b,1],
    [Fs5b,1],[A5b,1],[B5b,1],[A5b,1],
    [Fs5b,2],[D5b,1],[A4b,1],
    [D5b,4],
  ];

  // ── Chopin Nocturne Op. 9 No. 2 — Eb major, 66bpm ──
  const CHOPIN_BPM = 66;
  const CHOPIN_BEAT = 60 / CHOPIN_BPM;
  const CHOPIN_MELODY = [
    [466.16,2],[523.25,1],[466.16,1],
    [392.00,3],[0,1],
    [466.16,1],[622.25,2],[698.46,1],
    [783.99,4],
    [783.99,1],[698.46,1],[622.25,1],[587.33,1],
    [622.25,2],[466.16,1],[392.00,1],
    [466.16,1],[523.25,1],[622.25,1],[698.46,1],
    [622.25,4],
    [783.99,0.5],[698.46,0.5],[622.25,1],[698.46,1],[783.99,1],
    [932.33,2],[783.99,1],[622.25,1],
    [698.46,1],[622.25,1],[587.33,1],[523.25,1],
    [466.16,4],
    [622.25,1],[783.99,1],[932.33,1],[1046.50,1],
    [932.33,2],[783.99,2],
    [698.46,1],[622.25,1],[587.33,1],[622.25,1],
    [392.00,4],
  ];

  // ── Gymnopédie No. 1 — D major, 56bpm ──
  const GYMNO_BPM = 56;
  const GYMNO_BEAT = 60 / GYMNO_BPM;
  const GYMNO_MELODY = [
    [0,2],[587.33,2],[0,2],
    [493.88,4],[440.00,2],
    [0,2],[739.99,2],[0,2],
    [659.25,6],
    [0,2],[587.33,2],[0,2],
    [739.99,4],[659.25,2],
    [587.33,4],[493.88,2],
    [440.00,6],
    [0,2],[440.00,2],[0,2],
    [392.00,4],[369.99,2],
    [329.63,4],[293.66,2],
    [329.63,6],
    [0,2],[587.33,2],[0,2],
    [493.88,4],[440.00,2],
    [369.99,4],[293.66,2],
    [293.66,6],
  ];

  // ── Bach Prelude in C Major — C major, 72bpm ──
  const BACH_BPM = 72;
  const BACH_BEAT = 60 / BACH_BPM;
  const BACH_MELODY = [
    [261.63,0.5],[329.63,0.5],[392.00,0.5],[523.25,0.5],[659.25,0.5],[392.00,0.5],[523.25,0.5],[659.25,0.5],
    [261.63,0.5],[587.33,0.5],[440.00,0.5],[587.33,0.5],[698.46,0.5],[440.00,0.5],[587.33,0.5],[698.46,0.5],
    [246.94,0.5],[293.66,0.5],[392.00,0.5],[587.33,0.5],[698.46,0.5],[392.00,0.5],[587.33,0.5],[698.46,0.5],
    [261.63,0.5],[329.63,0.5],[392.00,0.5],[523.25,0.5],[659.25,0.5],[392.00,0.5],[523.25,0.5],[659.25,0.5],
    [261.63,0.5],[329.63,0.5],[440.00,0.5],[659.25,0.5],[880.00,0.5],[659.25,0.5],[880.00,0.5],[1046.50,0.5],
    [261.63,0.5],[293.66,0.5],[349.23,0.5],[440.00,0.5],[587.33,0.5],[698.46,0.5],[880.00,0.5],[587.33,0.5],
    [246.94,0.5],[293.66,0.5],[392.00,0.5],[587.33,0.5],[783.99,0.5],[587.33,0.5],[783.99,0.5],[987.77,0.5],
    [261.63,0.5],[329.63,0.5],[392.00,0.5],[523.25,0.5],[783.99,0.5],[659.25,0.5],[523.25,0.5],[392.00,0.5],
  ];

  const playNote = (ctx, masterGain, freq, startTime, duration, vol = 0.18) => {
    if (!freq) return;
    const osc = ctx.createOscillator();
    const env = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;
    env.gain.setValueAtTime(0, startTime);
    env.gain.linearRampToValueAtTime(vol, startTime + 0.03);
    env.gain.exponentialRampToValueAtTime(vol * 0.5, startTime + duration * 0.5);
    env.gain.exponentialRampToValueAtTime(0.001, startTime + duration * 0.92);
    osc.connect(env);
    env.connect(masterGain);
    osc.start(startTime);
    osc.stop(startTime + duration);
  };

  const playTrack = (ctx, gain, startTime, which) => {
    const melody = which === "waltz" ? WALTZ_MELODY
      : which === "clair" ? LOVE_MELODY
      : which === "crave" ? CRAVE_MELODY
      : which === "sun" ? SUN_MELODY
      : which === "rach" ? WALTZ_MELODY
      : which === "chopin" ? CHOPIN_MELODY
      : which === "gymno" ? GYMNO_MELODY
      : which === "bach" ? BACH_MELODY
      : which === "comptine" ? LOVE_MELODY
      : which === "little" ? LOVE_MELODY
      : which === "newhome" ? LOVE_MELODY
      : which === "primavera" ? LOVE_MELODY
      : which === "skating" ? CHOPIN_MELODY
      : which === "debby" ? CHOPIN_MELODY
      : which === "peacepiece" ? GYMNO_MELODY
      : which === "porzgoret" ? GYMNO_MELODY
      : which === "dolphinbefore" ? BEN_MELODY
      : which === "dolphinafter" ? BEN_MELODY
      : BEN_MELODY;
    const beat = which === "waltz" || which === "rach" ? WALTZ_BEAT
      : which === "clair" ? LOVE_BEAT
      : which === "crave" ? CRAVE_BEAT
      : which === "sun" ? SUN_BEAT
      : which === "chopin" ? CHOPIN_BEAT
      : which === "gymno" ? GYMNO_BEAT
      : which === "bach" ? BACH_BEAT
      : which === "comptine" ? LOVE_BEAT
      : which === "little" ? LOVE_BEAT
      : which === "newhome" ? LOVE_BEAT
      : which === "primavera" ? LOVE_BEAT
      : which === "skating" ? CHOPIN_BEAT
      : which === "debby" ? CHOPIN_BEAT
      : which === "peacepiece" ? GYMNO_BEAT
      : which === "porzgoret" ? GYMNO_BEAT
      : which === "dolphinbefore" ? BEN_BEAT
      : which === "dolphinafter" ? BEN_BEAT
      : BEN_BEAT;
    const art = which === "crave" ? 0.68 : which === "ben" ? 0.72 : which === "gymno" ? 0.95 : 0.88;
    let t = startTime;
    melody.forEach(([freq, beats]) => {
      playNote(ctx, gain, freq, t, beats * beat * art);
      t += beats * beat;
    });
    return t;
  };

  const startMusic = (which = track) => {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const gain = ctx.createGain();
      gain.gain.setValueAtTime(0, ctx.currentTime);
      gain.gain.linearRampToValueAtTime(0.75, ctx.currentTime + 1.8);
      gain.connect(ctx.destination);
      musicRef.current = { ctx, gain, running: true };

      const loop = (startTime) => {
        if (!musicRef.current.running) return;
        const endTime = playTrack(ctx, gain, startTime, which);
        const totalMs = (endTime - startTime) * 1000;
        musicRef.current.timeout = setTimeout(() => {
          if (musicRef.current.running) loop(ctx.currentTime);
        }, totalMs - 150);
      };

      loop(ctx.currentTime + 0.5);
    } catch(e) {}
  };

  const stopMusic = (cb) => {
    try {
      const ref = musicRef.current;
      musicRef.current = { ctx: null, gain: null, timeout: null, running: false };
      clearTimeout(ref.timeout);
      if (ref.gain) {
        try { ref.gain.gain.setValueAtTime(0, ref.ctx.currentTime); } catch {}
      }
      try { ref.ctx?.close(); } catch {}
    } catch {}
    cb && cb();
  };

  const toggleMusic = () => {
    if (musicOn) { stopMusic(); setMusicOn(false); }
    else { startMusic(track); setMusicOn(true); }
  };

  const switchTrack = (t) => {
    setTrack(t);
    if (musicOn) stopMusic(() => startMusic(t));
  };

  useEffect(() => {
    setTimeout(() => { startMusic("waltz"); setTrack("waltz"); setMusicMode("synth"); setMusicOn(true); }, 100);
    return () => stopMusic();
  }, []);

  const load = async () => {
    try {
      const res = await window.storage.list("journal:");
      if (res?.keys?.length) {
        const all = await Promise.all(res.keys.map(async k => {
          try { const r = await window.storage.get(k); return r ? JSON.parse(r.value) : null; } catch { return null; }
        }));
        setEntries(all.filter(Boolean).sort((a, b) => b.createdAt - a.createdAt));
      }
    } catch {}
    setLoading(false);
  };

  const startNew = (p = null) => { setPrompt(p); setText(""); setActiveEntry(null); setView("write"); };

  const save = async () => {
    if (!text.trim()) return;
    setSaving(true);
    const e = { id: activeEntry?.id || String(Date.now()), text: text.trim(), prompt, createdAt: activeEntry?.createdAt || Date.now(), updatedAt: Date.now() };
    try { await window.storage.set(`journal:${e.id}`, JSON.stringify(e)); await load(); setActiveEntry(e); setView("read"); } catch {}
    setSaving(false);
  };

  const del = async (id) => {
    try { await window.storage.delete(`journal:${id}`); await load(); setConfirmDel(null); setView("list"); } catch {}
  };

  const fmtDate = ts => new Date(ts).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
  const fmtTime = ts => new Date(ts).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
  const wc = t => t.trim() ? t.trim().split(/\s+/).length : 0;
  const ALL_PROMPTS = Object.values(JOURNAL_PROMPTS).flat();
  const activePrompts = (!promptFollow || !musicOn) && !promptFollow
    ? ALL_PROMPTS
    : promptFollow && musicOn
      ? JOURNAL_PROMPTS[track] || JOURNAL_PROMPTS.default
      : JOURNAL_PROMPTS.default;
  useEffect(() => { setPromptIdx(0); setPrompt(null); }, [track, musicOn, promptFollow]);
  const cyclePrompt = () => { const n = (promptIdx + 1) % activePrompts.length; setPromptIdx(n); setPrompt(activePrompts[n]); };
  const currentPrompt = activePrompts[promptIdx];


  const TRACK_LABELS = { waltz: "Magic Waltz", comptine: "Comptine d'un autre été", little: "Little Moments", skating: "Skating in Central Park", crave: "The Crave", sun: "Another Day of Sun", newhome: "New Home", primavera: "Primavera", ben: "本色", debby: "Waltz for Debby", rach: "Prelude in G Minor", clair: "Clair de Lune", peacepiece: "Peace Piece", chopin: "Nocturne Op. 9 No. 2", gymno: "Gymnopédie No. 1", porzgoret: "Porz Goret", bach: "Prelude in C Major", dolphinbefore: "The Dolphin Before", dolphinafter: "The Dolphin After" };
  const trackLabel = TRACK_LABELS[track] || track;

  if (loading) return <div style={{ padding: "40px 0", textAlign: "center", color: T.textDim, fontFamily: mono, fontSize: "12px" }}>loading...</div>;

  return (
    <div>
      {/* music bar — spotify + synth for each track */}
      {(() => { return (
      <div style={{ marginBottom: "20px", paddingBottom: "14px", borderBottom: `1px solid ${T.border}` }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          {[
            { t: "waltz",  label: "Magic Waltz" },
            { t: "comptine", label: "Comptine d'un autre été" },
            { t: "little", label: "Little Moments" },
            { t: "skating", label: "Skating in Central Park" },
            { t: "sun",    label: "Another Day of Sun" },
            { t: "newhome", label: "New Home" },
            { t: "primavera", label: "Primavera" },
            { t: "crave",  label: "The Crave" },
            { t: "ben",    label: "本色" },
            { t: "debby",  label: "Waltz for Debby" },
            { t: "chopin", label: "Nocturne Op. 9 No. 2" },
            { t: "clair",  label: "Clair de Lune" },
            { t: "peacepiece", label: "Peace Piece" },
            { t: "gymno",  label: "Gymnopédie No. 1" },
            { t: "porzgoret", label: "Porz Goret" },
            { t: "bach",   label: "Prelude in C Major" },
            { t: "rach",   label: "Prelude in G Minor" },
            { t: "dolphinbefore", label: "The Dolphin Before" },
            { t: "dolphinafter", label: "The Dolphin After" },
          ].map(({ t, label }) => {
            const spotifyActive = musicOn && track === t && musicMode === "spotify";
            const synthActive   = musicOn && track === t && musicMode === "synth";
            return (
              <div key={t} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                {/* synth button */}
                <button onClick={() => {
                  if (synthActive) { stopMusic(); setMusicOn(false); }
                  else {
                    stopMusic();
                    setTimeout(() => { startMusic(t); setTrack(t); setMusicMode("synth"); setMusicOn(true); }, 50);
                  }
                }} style={{
                  background: "none",
                  border: `1px solid ${synthActive ? T.accent : T.border}`,
                  borderRadius: "4px", cursor: "pointer", padding: "4px 10px",
                  fontFamily: mono, fontSize: "10px",
                  color: synthActive ? T.accent : T.textDim, transition: "all 0.18s",
                }}>{synthActive ? "■ " : "▷ "}{label} (synth)</button>
                {/* spotify button — only if available */}
                {SPOTIFY_IDS[t] && <button onClick={() => {
                  if (spotifyActive) { stopMusic(); setMusicOn(false); }
                  else {
                    stopMusic();
                    setTrack(t); setMusicMode("spotify"); setMusicOn(true);
                  }
                }} style={{
                  background: "none",
                  border: `1px solid ${spotifyActive ? "#1DB954" : T.border}`,
                  borderRadius: "4px", cursor: "pointer", padding: "4px 10px",
                  fontFamily: mono, fontSize: "10px",
                  color: spotifyActive ? "#1DB954" : T.textDim, transition: "all 0.18s",
                }}>{spotifyActive ? "■ " : "▷ "}{label}</button>}
              </div>
            );
          })}
        </div>
        {/* spotify embed — shows when a spotify track is active */}
        {musicOn && musicMode === "spotify" && SPOTIFY_IDS[track] && (
          <div style={{ marginTop: "10px" }}>
            <iframe
              key={track}
              src={`https://open.spotify.com/embed/track/${SPOTIFY_IDS[track]}?utm_source=generator&theme=0`}
              width="100%" height="80" frameBorder="0"
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
              style={{ borderRadius: "6px", border: `1px solid ${T.border}` }}
            />
          </div>
        )}
        {/* synth description */}
        <div style={{ marginTop: "10px" }}>
          <span style={{ fontSize: "11px", fontFamily: mono, color: T.textDim }}>
            synthesized from the original melody · runs entirely in your browser · Spotify streams the real thing
          </span>
        </div>
      </div>
      );})()}

      {view === "write" && (
        <div>
          <div style={{ display: "flex", gap: "8px", alignItems: "center", marginBottom: "20px" }}>
            <Btn small onClick={() => setView(activeEntry ? "read" : "list")}>← back</Btn>
            <span style={{ marginLeft: "auto", fontFamily: mono, fontSize: "11px", color: T.textDim }}>{wc(text)} words</span>
          </div>
          {prompt ? (
            <div style={{ marginBottom: "20px", padding: "12px 14px", background: T.surface, border: `1px solid ${T.border}`, borderLeft: `2px solid ${T.accent}`, borderRadius: "4px" }}>
              <div style={{ fontSize: "10px", fontFamily: mono, color: T.accent, marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.1em" }}>prompt</div>
              <p style={{ margin: "0 0 8px", fontSize: "14px", color: T.text, lineHeight: 1.6, fontFamily: sans }}>{prompt.text}</p>
              <div style={{ fontSize: "11px", fontFamily: mono, color: T.textDim }}>— {prompt.source}</div>
            </div>
          ) : (
            <div style={{ marginBottom: "20px" }}>
              <Btn small onClick={() => setPrompt(currentPrompt)}>+ add prompt</Btn>
            </div>
          )}
          <textarea ref={taRef} value={text} onChange={e => setText(e.target.value)}
            placeholder="Begin anywhere."
            style={{ width: "100%", boxSizing: "border-box", background: "transparent", border: "none", borderBottom: `1px solid ${T.border}`, color: T.text, outline: "none", fontFamily: sans, fontSize: "15px", lineHeight: 1.8, padding: "0 0 20px", resize: "none", minHeight: "260px", caretColor: T.accent }}
            onInput={e => { e.target.style.height = "auto"; e.target.style.height = e.target.scrollHeight + "px"; }}
          />
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "16px" }}>
            {prompt && <Btn small onClick={cyclePrompt}>different prompt</Btn>}
            <Btn primary onClick={save} disabled={!text.trim() || saving}>{saving ? "saving..." : "Save"}</Btn>
          </div>
        </div>
      )}

      {view === "read" && activeEntry && (
        <div>
          <div style={{ display: "flex", gap: "8px", alignItems: "center", marginBottom: "20px" }}>
            <Btn small onClick={() => setView("list")}>← all entries</Btn>
            <div style={{ marginLeft: "auto", display: "flex", gap: "6px" }}>
              <Btn small onClick={() => setView("write")}>edit</Btn>
              {confirmDel === activeEntry.id
                ? <><Btn small danger onClick={() => del(activeEntry.id)}>confirm delete</Btn><Btn small onClick={() => setConfirmDel(null)}>cancel</Btn></>
                : <Btn small onClick={() => setConfirmDel(activeEntry.id)}>delete</Btn>}
            </div>
          </div>
          <div style={{ fontFamily: mono, fontSize: "11px", color: T.textDim, marginBottom: "16px" }}>
            {fmtDate(activeEntry.createdAt)} · {fmtTime(activeEntry.createdAt)} · {wc(activeEntry.text)} words
          </div>
          {activeEntry.prompt && (
            <div style={{ marginBottom: "20px", padding: "10px 14px", background: T.surface, border: `1px solid ${T.border}`, borderLeft: `2px solid ${T.accentDim}`, borderRadius: "4px" }}>
              <p style={{ margin: 0, fontSize: "13px", color: T.textMid, lineHeight: 1.6, fontFamily: sans }}>{activeEntry.prompt.text}</p>
            </div>
          )}
          <p style={{ fontSize: "15px", lineHeight: 1.85, color: T.text, fontFamily: sans, whiteSpace: "pre-wrap", paddingBottom: "24px", borderBottom: `1px solid ${T.border}`, margin: 0 }}>{activeEntry.text}</p>
        </div>
      )}

      {view === "prompts" && (
        <div>
          <div style={{ display: "flex", gap: "8px", alignItems: "center", marginBottom: "20px" }}>
            <Btn small onClick={() => setView("list")}>← back</Btn>
            <span style={{ fontFamily: mono, fontSize: "11px", color: T.textDim, marginLeft: "8px" }}>
              {activePrompts.length} prompts
              {musicOn && <span style={{ color: T.accent }}> · {trackLabel}</span>}
            </span>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
            {activePrompts.map(p => (
              <div key={p.id} style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: "4px", padding: "14px 16px", transition: "border-color 0.12s" }}
                onMouseEnter={e => e.currentTarget.style.borderColor = T.borderFocus}
                onMouseLeave={e => e.currentTarget.style.borderColor = T.border}
              >
                <p style={{ margin: "0 0 10px", fontSize: "14px", color: T.text, lineHeight: 1.6, fontFamily: sans }}>{p.text}</p>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontSize: "11px", fontFamily: mono, color: T.textDim }}>— {p.source}</span>
                  <Btn small onClick={() => startNew(p)}>write to this</Btn>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {view === "list" && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
          </div>

          <div style={{ marginBottom: "24px", padding: "16px", background: T.surface, border: `1px solid ${T.border}`, borderLeft: `2px solid ${T.accent}`, borderRadius: "4px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
              <div style={{ fontSize: "10px", fontFamily: mono, color: musicOn ? T.accent : T.textDim, textTransform: "uppercase", letterSpacing: "0.1em" }}>
                {musicOn
                  ? `✦ ${trackLabel}`
                  : "today's prompt"}
              </div>
              <button onClick={() => setView("prompts")} style={{ background: T.accent, border: `1px solid ${T.accent}`, borderRadius: "4px", color: T.bg, cursor: "pointer", padding: "4px 12px", fontSize: "12px", fontFamily: mono, fontWeight: 600, transition: "opacity 0.12s" }}
                onMouseEnter={e => e.currentTarget.style.opacity = "0.8"}
                onMouseLeave={e => e.currentTarget.style.opacity = "1"}
              >see all prompts →</button>
            </div>
            <p style={{ margin: "0 0 14px", fontSize: "14px", color: T.text, lineHeight: 1.65, fontFamily: sans }}>{currentPrompt.text}</p>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: "11px", fontFamily: mono, color: T.textDim }}>— {currentPrompt.source}</span>
              <div style={{ display: "flex", gap: "6px" }}>
                <Btn small onClick={cyclePrompt}>shuffle</Btn>
                <Btn small onClick={() => startNew(currentPrompt)}>write to this</Btn>
              </div>
            </div>
            {/* music → prompt hint + toggle */}
            <div style={{ marginTop: "12px", paddingTop: "10px", borderTop: `1px solid ${T.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: "11px", fontFamily: mono, color: T.textDim }}>
                {promptFollow && musicOn
                  ? <>prompts inspired by <span style={{ color: T.accent }}>✦ {trackLabel}</span> · hear it differently? try <span style={{ color: T.accent, cursor: "pointer" }} onClick={() => { setPromptFollow(false); setPromptIdx(0); setPrompt(null); }}>free shuffle</span></>
                  : promptFollow && !musicOn
                    ? <>pick a song above <span style={{ color: T.accent }}>↑</span> — prompts will draw from that mood, or use <span style={{ color: T.accent, cursor: "pointer" }} onClick={() => { setPromptFollow(false); setPromptIdx(0); setPrompt(null); }}>free shuffle</span></>
                    : <span style={{ color: T.textDim }}>free shuffle · prompts from all moods, no interpretation</span>
                }
              </span>
              <div style={{ display: "flex", gap: "0px", marginLeft: "12px", flexShrink: 0 }}>
                <button onClick={() => { setPromptFollow(true); setPromptIdx(0); setPrompt(null); }} style={{
                  background: "none", cursor: "pointer", padding: "2px 8px",
                  fontFamily: mono, fontSize: "10px", transition: "all 0.15s",
                  border: `1px solid ${promptFollow ? T.accent : T.border}`,
                  borderRadius: "4px 0 0 4px",
                  color: promptFollow ? T.accent : T.textDim,
                }}>follow music</button>
                <button onClick={() => { setPromptFollow(false); setPromptIdx(0); setPrompt(null); }} style={{
                  background: "none", cursor: "pointer", padding: "2px 8px",
                  fontFamily: mono, fontSize: "10px", transition: "all 0.15s",
                  border: `1px solid ${!promptFollow ? T.accent : T.border}`,
                  borderLeft: "none",
                  borderRadius: "0 4px 4px 0",
                  color: !promptFollow ? T.accent : T.textDim,
                }}>free shuffle</button>
              </div>
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
            <span style={{ fontFamily: mono, fontSize: "11px", color: T.textDim }}>{entries.length} {entries.length === 1 ? "entry" : "entries"}</span>
            <Btn small primary onClick={() => startNew()}>+ new entry</Btn>
          </div>

          {entries.length === 0 ? (
            <div style={{ padding: "48px 0", textAlign: "center" }}>
              <p style={{ fontFamily: mono, fontSize: "13px", color: T.textDim, margin: 0 }}>no entries yet</p>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
              {entries.map(e => (
                <button key={e.id} onClick={() => { setActiveEntry(e); setText(e.text); setPrompt(e.prompt); setView("read"); }}
                  style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: "4px", padding: "14px 16px", textAlign: "left", cursor: "pointer", width: "100%", transition: "border-color 0.12s" }}
                  onMouseEnter={ev => ev.currentTarget.style.borderColor = T.borderFocus}
                  onMouseLeave={ev => ev.currentTarget.style.borderColor = T.border}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
                    <span style={{ fontFamily: mono, fontSize: "11px", color: T.accent }}>{fmtDate(e.createdAt)}</span>
                    <span style={{ fontFamily: mono, fontSize: "11px", color: T.textDim }}>{wc(e.text)}w</span>
                  </div>
                  {e.prompt && <div style={{ fontFamily: mono, fontSize: "11px", color: T.textDim, marginBottom: "4px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>prompt: {e.prompt.text.slice(0, 55)}...</div>}
                  <p style={{ margin: 0, fontSize: "13px", color: T.textMid, lineHeight: 1.5, fontFamily: sans, overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>{e.text.slice(0, 140)}{e.text.length > 140 ? "..." : ""}</p>
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ── CHAT ──────────────────────────────────────────────────
function ChatTab() {
  const [char, setChar] = useState(null);
  const [msgs, setMsgs] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [streamingText, setStreamingText] = useState("");
  const [isStreaming, setIsStreaming] = useState(false);
  const [ambientOn, setAmbientOn] = useState(true);
  const bottomRef = useRef(null);
  const audioCtxRef = useRef(null);
  const ambientRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [msgs, loading, streamingText]);

  const stopAmbient = () => {
    try {
      const g = ambientRef.current?.gainNode;
      if (g && audioCtxRef.current) g.gain.setTargetAtTime(0, audioCtxRef.current.currentTime, 0.6);
      setTimeout(() => {
        try { ambientRef.current?.source?.stop(); } catch {}
        try { ambientRef.current?.sources?.forEach(s => s.stop()); } catch {}
        try { ambientRef.current?.oscs?.forEach(o => o.stop()); } catch {}
        try { audioCtxRef.current?.close(); } catch {}
        ambientRef.current = null;
        audioCtxRef.current = null;
      }, 1000);
    } catch {}
  };

  const startAmbient = (charName) => {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      audioCtxRef.current = ctx;

      const master = ctx.createGain();
      master.gain.value = 0;
      master.connect(ctx.destination);

      const makeNoise = () => {
        const buf = ctx.createBuffer(1, 2 * ctx.sampleRate, ctx.sampleRate);
        const d = buf.getChannelData(0);
        for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
        const s = ctx.createBufferSource();
        s.buffer = buf; s.loop = true;
        return s;
      };

      const mkFilter = (type, freq, Q = 1) => {
        const f = ctx.createBiquadFilter();
        f.type = type; f.frequency.value = freq; f.Q.value = Q;
        return f;
      };

      const mkOsc = (freq, type = "sine") => {
        const o = ctx.createOscillator();
        o.type = type; o.frequency.value = freq;
        return o;
      };

      const mkGain = (vol) => { const g = ctx.createGain(); g.gain.value = vol; return g; };

      const sources = [], oscs = [];

      if (!charName) {
        // generic white noise room hum — plays on character select screen
        const n = makeNoise();
        const lp = mkFilter("lowpass", 320);
        n.connect(lp); lp.connect(master);
        n.start(); sources.push(n);
        master.gain.setTargetAtTime(0.035, ctx.currentTime, 1.5);

      } else if (charName === "BoJack Horseman") {
        // big empty house, 2am. tv on somewhere. low drone.
        // raised into audible range — laptop speakers start at ~100hz
        const room = makeNoise();
        const lp = mkFilter("lowpass", 600);
        const hp = mkFilter("highpass", 80);
        room.connect(hp); hp.connect(lp); lp.connect(master);
        room.start(); sources.push(room);

        // tv hum — 180hz fundamental (3rd harmonic of 60hz, audible on all speakers)
        const tv = mkOsc(180, "sawtooth");
        const tvF = mkFilter("lowpass", 400);
        const tvG = mkGain(0.12);
        tv.connect(tvF); tvF.connect(tvG); tvG.connect(master);
        tv.start(); oscs.push(tv);

        // melancholic drone — E3 (164hz), audible, slow vibrato
        const drone = mkOsc(164.8, "sine");
        const vib = mkOsc(0.3, "sine");
        const vibG = mkGain(3);
        vib.connect(vibG); vibG.connect(drone.frequency);
        const droneG = mkGain(0.25);
        drone.connect(droneG); droneG.connect(master);
        drone.start(); vib.start(); oscs.push(drone, vib);

        // distant upper harmonic — gives it that hollow, empty quality
        const upper = mkOsc(329.6, "sine"); // E4
        const upperG = mkGain(0.08);
        upper.connect(upperG); upperG.connect(master);
        upper.start(); oscs.push(upper);

        master.gain.setTargetAtTime(0.06, ctx.currentTime, 2);

      } else if (charName === "Diane Nguyen") {
        // chicago apartment. rain on window. radiator warmth.
        const rain = makeNoise();
        const hp = mkFilter("highpass", 800);
        const bp = mkFilter("bandpass", 2400, 0.6);
        const lp = mkFilter("lowpass", 6000);
        rain.connect(hp); hp.connect(bp); bp.connect(lp); lp.connect(master);
        rain.start(); sources.push(rain);

        const street = makeNoise();
        const streetLp = mkFilter("lowpass", 180);
        const streetG = mkGain(0.4);
        street.connect(streetLp); streetLp.connect(streetG); streetG.connect(master);
        street.start(); sources.push(street);

        const rad = mkOsc(110, "sine");
        const radG = mkGain(0.18);
        rad.connect(radG); radG.connect(master);
        rad.start(); oscs.push(rad);

        master.gain.setTargetAtTime(0.045, ctx.currentTime, 2);

      } else if (charName === "Princess Carolyn") {
        // hollywood office. hvac. fluorescent. perpetual motion.
        const hvacNoise = makeNoise();
        const hp = mkFilter("highpass", 200);
        const lp = mkFilter("lowpass", 900);
        hvacNoise.connect(hp); hp.connect(lp); lp.connect(master);
        hvacNoise.start(); sources.push(hvacNoise);

        const hvac = mkOsc(118, "sawtooth");
        const hvacF = mkFilter("lowpass", 220);
        const hvacG = mkGain(0.18);
        hvac.connect(hvacF); hvacF.connect(hvacG); hvacG.connect(master);
        hvac.start(); oscs.push(hvac);

        const fluor = mkOsc(3960, "sine");
        const flourG = mkGain(0.08);
        fluor.connect(flourG); flourG.connect(master);
        fluor.start(); oscs.push(fluor);

        master.gain.setTargetAtTime(0.038, ctx.currentTime, 1.5);

      } else if (charName === "Mr. Peanutbutter") {
        // sunny bel air. warm open. celebratory G major.
        const sun = makeNoise();
        const bp = mkFilter("bandpass", 1400, 1.2);
        const lp = mkFilter("lowpass", 4000);
        sun.connect(bp); bp.connect(lp); lp.connect(master);
        sun.start(); sources.push(sun);

        [[196, 0.22], [246.94, 0.18], [293.66, 0.16], [392, 0.14]].forEach(([freq, vol]) => {
          const o = mkOsc(freq, "sine");
          const vib = mkOsc(4.2, "sine");
          const vibG = mkGain(2.5);
          vib.connect(vibG); vibG.connect(o.frequency);
          const g = mkGain(vol);
          o.connect(g); g.connect(master);
          o.start(); vib.start(); oscs.push(o, vib);
        });

        master.gain.setTargetAtTime(0.032, ctx.currentTime, 2);

      } else if (charName === "Todd Chavez") {
        // wherever todd is. mid noise. soft irregular pings.
        const room = makeNoise();
        const bp = mkFilter("bandpass", 700, 0.7);
        room.connect(bp); bp.connect(master);
        room.start(); sources.push(room);

        const pingFreqs = [523.25, 659.25, 783.99, 1046.5];
        let pingActive = true;
        const doPing = () => {
          if (!pingActive || ctx.state === "closed") return;
          const freq = pingFreqs[Math.floor(Math.random() * pingFreqs.length)];
          const o = ctx.createOscillator();
          const g = ctx.createGain();
          o.type = "sine"; o.frequency.value = freq;
          g.gain.setValueAtTime(0, ctx.currentTime);
          g.gain.linearRampToValueAtTime(0.6, ctx.currentTime + 0.06);
          g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 1.4);
          o.connect(g); g.connect(master);
          o.start(); o.stop(ctx.currentTime + 1.5);
          setTimeout(doPing, 2200 + Math.random() * 4800);
        };
        setTimeout(doPing, 1200);
        sources.push({ stop: () => { pingActive = false; } });

        master.gain.setTargetAtTime(0.04, ctx.currentTime, 1.8);
      }

      ambientRef.current = { source: null, sources, oscs, gainNode: master };
      setAmbientOn(true);
    } catch(e) {}
  };

  const toggleAmbient = () => {
    if (ambientOn) { stopAmbient(); setAmbientOn(false); }
    else { startAmbient(char?.name); }
  };

  useEffect(() => {
    // start generic white noise the moment user enters Talk tab
    startAmbient();
    return () => stopAmbient();
  }, []);

  const greetings = {
    "BoJack Horseman": "Oh great, another person who wants to talk to me. Look, I'm flattered — no, actually I'm not. What do you want?",
    "Diane Nguyen": "Hi. I'm... yeah, I'm around. What's on your mind? I've been trying to be more present lately, so — I'm here.",
    "Princess Carolyn": "You've got thirty seconds. I'm juggling seventeen things and a toddler. What do you need?",
    "Mr. Peanutbutter": "OH WOW, a new friend!! This is already the best conversation I've had today and you haven't even said anything yet! Hi hi hi!!",
    "Todd Chavez": "Oh hey! I was just thinking about something — actually it can wait. What's up?",
  };

  const pick = c => {
    setChar(c);
    setMsgs([{ role: "assistant", text: greetings[c.name] }]);
    setInput("");
    setStreamingText("");
    setIsStreaming(false);
    setTimeout(() => inputRef.current?.focus(), 100);
    // fade out current, start character sound
    if (ambientOn) {
      stopAmbient();
      setTimeout(() => startAmbient(c.name), 800);
    }
  };


  const send = async () => {
    const t = input.trim();
    if (!t || loading || isStreaming) return;
    const next = [...msgs, { role: "user", text: t }];
    setMsgs(next);
    setInput("");
    setLoading(true);

    try {
      const res = await fetch("/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "claude-sonnet-4-5-20250929",
          max_tokens: 1000,
          system: char.system,
          messages: next.map(m => ({ role: m.role === "assistant" ? "assistant" : "user", content: m.text })),
        }),
      });
      const data = await res.json();
      const fullText = (data.content || []).map(b => b.text || "").join("").trim();
      if (!res.ok || !fullText) throw new Error("generation failed");

      // pause before starting — let the dots breathe
      await new Promise(r => setTimeout(r, 420));
      setLoading(false);
      setIsStreaming(true);

      // word-by-word reveal
      const words = fullText.split(" ");
      let revealed = "";
      for (let i = 0; i < words.length; i++) {
        revealed += (i === 0 ? "" : " ") + words[i];
        setStreamingText(revealed);
        const delay = i < 3 ? 55 : 28 + Math.random() * 25;
        await new Promise(r => setTimeout(r, delay));
      }

      setMsgs(p => [...p, { role: "assistant", text: fullText }]);
      setStreamingText("");
      setIsStreaming(false);
      setTimeout(() => inputRef.current?.focus(), 50);
    } catch {
      setLoading(false);
      setIsStreaming(false);
      setStreamingText("");
      setMsgs(p => [...p, { role: "assistant", text: FUND_MESSAGE }]);
    }
  };

  const busy = loading || isStreaming;

  if (!char) return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "12px" }}>
        <button
          onClick={toggleAmbient}
          style={{
            background: "none", border: `1px solid ${ambientOn ? T.borderFocus : T.border}`,
            borderRadius: "4px", cursor: "pointer", padding: "4px 10px",
            fontFamily: mono, fontSize: "10px", letterSpacing: "0.06em",
            color: ambientOn ? T.textMid : T.textDim, transition: "all 0.2s",
          }}
        >{ambientOn ? "♪ on" : "♪ off"}</button>
      </div>
      <Divider label="select character" />
      <div style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
        {CHAT_CHARACTERS.map(c => (
          <button key={c.name} onClick={() => pick(c)}
            style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: "4px", padding: "14px 16px", display: "flex", alignItems: "center", gap: "14px", cursor: "pointer", textAlign: "left", width: "100%", transition: "border-color 0.12s" }}
            onMouseEnter={e => e.currentTarget.style.borderColor = T.borderFocus}
            onMouseLeave={e => e.currentTarget.style.borderColor = T.border}
          >
            <span style={{ fontSize: "20px", width: "28px", textAlign: "center" }}>{c.emoji}</span>
            <div>
              <div style={{ fontSize: "14px", color: T.text, fontFamily: sans, marginBottom: "2px", fontWeight: 500 }}>{c.name}</div>
              <div style={{ fontSize: "12px", color: T.textDim, fontFamily: mono }}>{c.tagline}</div>
            </div>
            <span style={{ marginLeft: "auto", color: T.textDim, fontSize: "14px" }}>→</span>
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 280px)", minHeight: "420px" }}>

      {/* header */}
      <div style={{ display: "flex", gap: "8px", alignItems: "center", marginBottom: "16px", paddingBottom: "12px", borderBottom: `1px solid ${T.border}` }}>
        <Btn small onClick={() => {
          setChar(null); setMsgs([]); setStreamingText(""); setIsStreaming(false);
          stopAmbient();
          setAmbientOn(false);
        }}>← back</Btn>
        <span style={{ fontSize: "16px" }}>{char.emoji}</span>
        <span style={{ fontSize: "14px", color: T.text, fontFamily: sans, fontWeight: 500 }}>{char.name}</span>
        <div style={{ marginLeft: "auto", display: "flex", gap: "8px", alignItems: "center" }}>
          {/* ambient toggle */}
          <button
            onClick={toggleAmbient}
            title={ambientOn ? "turn off ambient sound" : "turn on ambient sound"}
            style={{
              background: "none", border: `1px solid ${ambientOn ? T.borderFocus : T.border}`,
              borderRadius: "4px", cursor: "pointer", padding: "4px 8px",
              fontFamily: mono, fontSize: "10px", letterSpacing: "0.06em",
              color: ambientOn ? T.textMid : T.textDim,
              transition: "all 0.2s",
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = T.borderFocus; e.currentTarget.style.color = T.textMid; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = ambientOn ? T.borderFocus : T.border; e.currentTarget.style.color = ambientOn ? T.textMid : T.textDim; }}
          >
            {ambientOn ? "♪ on" : "♪ off"}
          </button>
          <Btn small onClick={() => { setMsgs([{ role: "assistant", text: greetings[char.name] }]); setStreamingText(""); setIsStreaming(false); }}>clear</Btn>
        </div>
      </div>
      {/* interpretation note */}
      <div style={{ padding: "6px 0 10px", borderBottom: `1px solid ${T.border}`, marginBottom: "4px" }}>
        <span style={{ fontSize: "11px", fontFamily: mono, color: T.textDim }}>
          responses inspired by <span style={{ color: T.accent }}>✦ {char.name}</span> · hear {char.name === "Mr. Peanutbutter" ? "him" : char.name === "Princess Carolyn" ? "her" : char.name === "Diane Nguyen" ? "her" : char.name === "Todd Chavez" ? "him" : "him"} differently? that's valid too
        </span>
      </div>

      {/* messages */}
      <div style={{ flex: 1, overflowY: "auto", display: "flex", flexDirection: "column", gap: "14px", paddingRight: "4px", marginBottom: "16px" }}>
        {msgs.map((m, i) => (
          <div key={i} style={{ display: "flex", justifyContent: m.role === "user" ? "flex-end" : "flex-start", gap: "10px", alignItems: "flex-end" }}>
            {m.role === "assistant" && (
              <span style={{ fontSize: "16px", flexShrink: 0, marginBottom: "2px" }}>{char.emoji}</span>
            )}
            <div style={{
              maxWidth: "74%",
              padding: "11px 15px",
              borderRadius: m.role === "user" ? "12px 12px 3px 12px" : "12px 12px 12px 3px",
              background: m.role === "user" ? "#181818" : T.surface,
              border: `1px solid ${m.role === "user" ? "#2a2a2a" : T.border}`,
              fontSize: "14px", lineHeight: 1.7, color: T.text, fontFamily: sans,
            }}>{m.text}</div>
          </div>
        ))}

        {/* typing indicator */}
        {loading && (
          <div style={{ display: "flex", gap: "10px", alignItems: "flex-end" }}>
            <span style={{ fontSize: "16px", flexShrink: 0 }}>{char.emoji}</span>
            <div style={{ padding: "12px 16px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: "12px 12px 12px 3px", display: "flex", gap: "5px", alignItems: "center" }}>
              {[0, 1, 2].map(i => (
                <div key={i} style={{ width: "5px", height: "5px", borderRadius: "50%", background: T.textDim, animation: `pulse 1.4s ease-in-out ${i * 0.18}s infinite` }} />
              ))}
            </div>
          </div>
        )}

        {/* streaming word-by-word */}
        {isStreaming && streamingText && (
          <div style={{ display: "flex", gap: "10px", alignItems: "flex-end" }}>
            <span style={{ fontSize: "16px", flexShrink: 0 }}>{char.emoji}</span>
            <div style={{
              maxWidth: "74%",
              padding: "11px 15px",
              borderRadius: "12px 12px 12px 3px",
              background: T.surface,
              border: `1px solid ${T.border}`,
              fontSize: "14px", lineHeight: 1.7, color: T.text, fontFamily: sans,
            }}>
              {streamingText}
              <span style={{ display: "inline-block", width: "2px", height: "13px", background: T.textDim, marginLeft: "2px", verticalAlign: "middle", animation: "pulse 0.9s ease-in-out infinite" }} />
            </div>
          </div>
        )}

        <div ref={bottomRef} />
      </div>

      {/* input */}
      <div style={{ display: "flex", gap: "8px" }}>
        <Input
          ref={inputRef}
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === "Enter" && !busy && send()}
          placeholder={busy ? "" : `Message ${char.name.split(" ")[0]}...`}
          disabled={busy}
          style={{ opacity: busy ? 0.5 : 1 }}
        />
        <button
          onClick={send}
          disabled={busy || !input.trim()}
          style={{
            background: T.white, border: `1px solid ${T.white}`, borderRadius: "4px",
            color: T.bg, cursor: busy || !input.trim() ? "not-allowed" : "pointer",
            padding: "8px 16px", fontSize: "13px", fontFamily: mono,
            opacity: busy || !input.trim() ? 0.25 : 1, transition: "opacity 0.15s",
            whiteSpace: "nowrap",
          }}
        >send</button>
      </div>
    </div>
  );
}

// ── EPISODE TONES ──────────────────────────────────────────
const EPISODE_TONES = {
  "Fish Out of Water":              "silent · tender",
  "Free Churro":                    "monologue · devastating",
  "Time's Arrow":                   "experimental · heartbreaking",
  "The View From Halfway Down":     "dream · devastating",
  "Nice While It Lasted":           "quiet · final",
  "Downer Ending":                  "dark · raw",
  "Later":                          "melancholy · open",
  "The Telescope":                  "painful · honest",
  "Hank After Dark":                "sharp · satirical",
  "The Showstopper":                "hallucinatory · dark",
  "Mr. Peanutbutter's Boos":        "funny · melancholy",
  "Good Damage":                    "introspective · tender",
  "Thoughts and Prayers":           "satirical · angry",
  "That's Too Much, Man!":          "chaotic · devastating",
  "The Dog Days Are Over":          "searching · quiet",
  "A Quick One, While He's Away":   "experimental · ensemble",
};

// ── SEASON BAR ────────────────────────────────────────────
const SEASON_META = [
  { s: 1, year: "2014", eps: 12 },
  { s: 2, year: "2015", eps: 12 },
  { s: 3, year: "2016", eps: 12 },
  { s: 4, year: "2017", eps: 12 },
  { s: 5, year: "2018", eps: 12 },
  { s: 6, year: "2019", eps: 16 },
];

function SeasonBar({ season, setSeason }) {
  const [hovered, setHovered] = useState(null);
  return (
    <div style={{ marginBottom: "16px" }}>
      <div style={{ display: "flex", gap: "3px", marginBottom: "6px" }}>
        {SEASON_META.map(({ s, year, eps }) => {
          const active = season === s;
          const isHov = hovered === s;
          return (
            <div
              key={s}
              onClick={() => setSeason(season === s ? null : s)}
              onMouseEnter={() => setHovered(s)}
              onMouseLeave={() => setHovered(null)}
              style={{
                flex: 1,
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                gap: "6px",
              }}
            >
              {/* bar segment */}
              <div style={{
                height: "3px",
                borderRadius: "2px",
                background: active
                  ? T.accent
                  : isHov
                  ? "#383838"
                  : "#222222",
                transition: "background 0.15s",
              }} />
              {/* labels */}
              <div style={{ display: "flex", flexDirection: "column", gap: "2px", paddingLeft: "1px" }}>
                <span style={{
                  fontFamily: mono,
                  fontSize: "11px",
                  color: active ? T.accent : isHov ? T.textMid : T.textDim,
                  transition: "color 0.15s",
                  fontWeight: active ? 600 : 400,
                }}>S{s}</span>
                <span style={{
                  fontFamily: mono,
                  fontSize: "10px",
                  color: active ? T.accentDim : "#3a3a3a",
                  transition: "color 0.15s",
                }}>{year}</span>
                <span style={{
                  fontFamily: mono,
                  fontSize: "10px",
                  color: active ? T.accentDim : "#333333",
                  transition: "color 0.15s",
                }}>{eps} ep</span>
              </div>
            </div>
          );
        })}
      </div>
      {/* clear link */}
      {season && (
        <button
          onClick={() => setSeason(null)}
          style={{ background: "none", border: "none", cursor: "pointer", fontFamily: mono, fontSize: "11px", color: T.textDim, padding: "0", marginTop: "2px", textDecoration: "underline" }}
          onMouseEnter={e => e.currentTarget.style.color = T.textMid}
          onMouseLeave={e => e.currentTarget.style.color = T.textDim}
        >clear filter</button>
      )}
    </div>
  );
}

// ── MAIN ──────────────────────────────────────────────────
export default function App() {
  const [query, setQuery] = useState("");
  const [tab, setTab] = useState("all");
  const [season, setSeason] = useState(null);
  const [expandedEp, setExpandedEp] = useState(null);
  const [aiChar, setAiChar] = useState("BoJack Horseman");
  const [aiMood, setAiMood] = useState("nihilistic");
  const [aiTopic, setAiTopic] = useState("");
  const [aiResult, setAiResult] = useState(null);
  const [aiLoading, setAiLoading] = useState(false);
  const [aiError, setAiError] = useState(null);
  const [bgMusicOn, setBgMusicOn] = useState(false);
  const [bgMode, setBgMode] = useState("synth"); // "synth" | "spotify"
  const bgMusicRef = useRef({ ctx: null, gain: null, timeout: null, running: false });

  // ── Back in the 90s — Grouplove, F# minor, ~126bpm ──
  const BG_BPM = 126;
  const BG_BEAT = 60 / BG_BPM;
  const Fs4bg=369.99, A4bg=440.00, B4bg=493.88, Cs5bg=554.37, D5bg=587.33,
        E4bg=329.63, E5bg=659.25, Fs5bg=739.99;

  const BG_MELODY = [
    // "Back in the 90s"
    [Cs5bg,1],[B4bg,1],[A4bg,1],[Fs4bg,1],
    [A4bg,2],[B4bg,1],[Cs5bg,1],
    // "I was in a very famous TV show"
    [A4bg,1],[B4bg,1],[Cs5bg,1],[B4bg,1],
    [A4bg,2],[Fs4bg,2],
    [E4bg,3],[0,1],
    // "I'm BoJack the horse, BoJack the horse"
    [Cs5bg,1],[B4bg,1],[A4bg,1],[Fs4bg,1],
    [B4bg,2],[A4bg,1],[Fs4bg,1],
    [A4bg,1],[B4bg,1],[Cs5bg,1],[B4bg,1],
    [A4bg,2],[Fs4bg,2],
    // "Don't act like you don't know"
    [E4bg,1],[Fs4bg,1],[A4bg,1],[B4bg,1],
    [A4bg,2],[Fs4bg,1],[E4bg,1],
    [Fs4bg,4],
    [0,2],
    // "And I'm trying to hold on to my past"
    [Fs4bg,1],[A4bg,1],[Cs5bg,1],[E5bg,1],
    [D5bg,2],[Cs5bg,1],[B4bg,1],
    [A4bg,4],
    // "It's been so long, I don't think I'm gonna last"
    [Cs5bg,1],[B4bg,1],[A4bg,1],[Fs4bg,1],
    [B4bg,2],[A4bg,1],[Fs4bg,1],
    [A4bg,3],[0,1],
    // "I guess I'll just try and make you understand"
    [Cs5bg,1],[B4bg,1],[A4bg,1],[B4bg,1],
    [Cs5bg,2],[D5bg,1],[Cs5bg,1],
    [B4bg,4],
    // "That I'm more horse than a man, or I'm more man than a horse"
    [E5bg,1],[D5bg,1],[Cs5bg,1],[B4bg,1],
    [A4bg,2],[Fs4bg,2],
    [E5bg,1],[D5bg,1],[Cs5bg,1],[B4bg,1],
    [A4bg,2],[E4bg,2],
    [Fs4bg,3],[0,1],
    // "BoJack!"
    [A4bg,1],[Cs5bg,1],[E5bg,2],
    [Fs5bg,4],
    [0,4],
  ];

  const bgPlayNote = (ctx, gain, freq, startTime, duration) => {
    if (!freq) return;
    const osc = ctx.createOscillator();
    const env = ctx.createGain();
    osc.type = "triangle";
    osc.frequency.value = freq;
    env.gain.setValueAtTime(0, startTime);
    env.gain.linearRampToValueAtTime(0.15, startTime + 0.025);
    env.gain.exponentialRampToValueAtTime(0.06, startTime + duration * 0.6);
    env.gain.exponentialRampToValueAtTime(0.001, startTime + duration * 0.95);
    osc.connect(env); env.connect(gain);
    osc.start(startTime); osc.stop(startTime + duration);
  };

  const startBgMusic = () => {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const gain = ctx.createGain();
      gain.gain.setValueAtTime(0, ctx.currentTime);
      gain.gain.linearRampToValueAtTime(0.8, ctx.currentTime + 1.5);
      gain.connect(ctx.destination);
      bgMusicRef.current = { ctx, gain, running: true };

      const loop = (startTime) => {
        if (!bgMusicRef.current.running) return;
        let t = startTime;
        BG_MELODY.forEach(([freq, beats]) => {
          bgPlayNote(ctx, gain, freq, t, beats * BG_BEAT * 0.82);
          t += beats * BG_BEAT;
        });
        const totalMs = (t - startTime) * 1000;
        bgMusicRef.current.timeout = setTimeout(() => {
          if (bgMusicRef.current.running) loop(ctx.currentTime);
        }, totalMs - 150);
      };
      loop(ctx.currentTime + 0.3);
      setBgMusicOn(true);
    } catch(e) {}
  };

  const stopBgMusic = () => {
    try {
      const ref = bgMusicRef.current;
      bgMusicRef.current = { ctx: null, gain: null, timeout: null, running: false };
      clearTimeout(ref.timeout);
      try { ref.gain?.gain.setValueAtTime(0, ref.ctx.currentTime); } catch {}
      try { ref.ctx?.close(); } catch {}
    } catch {}
    setBgMusicOn(false);
  };

  const toggleBgMusic = () => { if (bgMusicOn) stopBgMusic(); else startBgMusic(); };

  const filtered = useMemo(() => {
    const q = query.toLowerCase().trim();
    const s = x => !season || x.season === season;
    return {
      quotes: QUOTES.filter(x => s(x) && (!q || x.text.toLowerCase().includes(q) || x.character.toLowerCase().includes(q) || x.episode.toLowerCase().includes(q))),
      characters: CHARACTERS.filter(x => !q || x.name.toLowerCase().includes(q) || x.description.toLowerCase().includes(q) || x.actor.toLowerCase().includes(q)),
      episodes: EPISODES.filter(x => s(x) && (!q || x.title.toLowerCase().includes(q) || x.description.toLowerCase().includes(q))),
    };
  }, [query, season]);

  const total = filtered.quotes.length + filtered.characters.length + filtered.episodes.length;

  const hl = text => {
    if (!query.trim()) return text;
    const re = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    return text.split(re).map((p, i) => re.test(p) ? <mark key={i} style={{ background: "#3a4a3a", color: T.accent, borderRadius: "2px" }}>{p}</mark> : p);
  };

  const generate = async () => {
    setAiLoading(true); setAiResult(null); setAiError(null);
    try {
      const res = await fetch("/api/chat", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ model: "claude-sonnet-4-5-20250929", max_tokens: 1000, system: `You deeply understand BoJack Horseman. Write original quotes in the show's voice — dark humor, existential honesty, poignant insight. Respond ONLY with valid JSON, no markdown: {"quote":"...","context":"...one sentence scene setup..."}`, messages: [{ role: "user", content: `Write an original quote as ${aiChar}. Tone: ${aiMood}.${aiTopic ? ` Topic: "${aiTopic}".` : ""} Make it feel authentic to the show.` }] })
      });
      const data = await res.json();
      const raw = (data.content || []).map(b => b.text || "").join("").replace(/```json|```/g, "").trim();
      if (!res.ok || !raw) throw new Error("generation failed");
      setAiResult(JSON.parse(raw));
    } catch { setAiError(FUND_MESSAGE); }
    setAiLoading(false);
  };

  const isSpecial = ["ai", "chat", "journal"].includes(tab);
  const showSeason = !isSpecial && tab !== "characters";

  const card = { background: T.surface, border: `1px solid ${T.border}`, borderRadius: "4px", transition: "border-color 0.12s" };

  return (
    <div style={{ minHeight: "100vh", background: T.bg, color: T.text, fontFamily: sans }}>
      <style>{`
        @keyframes pulse { 0%,100%{opacity:0.3} 50%{opacity:1} }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(5px); } to { opacity: 1; transform: translateY(0); } }
        input::placeholder, textarea::placeholder { color: ${T.textDim}; }
        ::-webkit-scrollbar { width: 4px; }
        ::-webkit-scrollbar-thumb { background: #2a2a2a; border-radius: 2px; }
        * { box-sizing: border-box; }
      `}</style>

      {/* Header */}
      <div style={{ borderBottom: `1px solid ${T.border}`, padding: "24px 32px 0" }}>
        <div style={{ maxWidth: "780px", margin: "0 auto" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px", marginBottom: "16px" }}>
            <div style={{ display: "flex", alignItems: "baseline", gap: "10px" }}>
              <h1 style={{ fontSize: "18px", fontWeight: 600, margin: 0, color: T.white, fontFamily: sans }}>BoJack Horseman</h1>
              <span style={{ fontSize: "12px", fontFamily: mono, color: T.textDim }}>fan archive</span>
            </div>
            {/* music controls */}
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              {/* spotify */}
              <button onClick={() => {
                if (bgMode === "synth" && bgMusicOn) { stopBgMusic(); setBgMusicOn(false); }
                if (bgMode === "spotify" && bgMusicOn) { setBgMusicOn(false); }
                else { setBgMode("spotify"); setBgMusicOn(true); }
              }} style={{
                background: "none",
                border: `1px solid ${bgMusicOn && bgMode === "spotify" ? "#1DB954" : T.border}`,
                borderRadius: "4px", cursor: "pointer", padding: "3px 9px",
                fontFamily: mono, fontSize: "10px",
                color: bgMusicOn && bgMode === "spotify" ? "#1DB954" : T.textDim, transition: "all 0.2s",
              }}>{bgMusicOn && bgMode === "spotify" ? "■" : "▷"} Back in the 90's</button>
              {/* synth */}
              <button onClick={() => {
                if (bgMode === "spotify" && bgMusicOn) { setBgMusicOn(false); }
                setBgMode("synth");
                if (bgMode === "synth" && bgMusicOn) { stopBgMusic(); setBgMusicOn(false); }
                else { startBgMusic(); setBgMusicOn(true); }
              }} style={{
                background: "none",
                border: `1px solid ${bgMusicOn && bgMode === "synth" ? T.accent : T.border}`,
                borderRadius: "4px", cursor: "pointer", padding: "3px 9px",
                fontFamily: mono, fontSize: "10px",
                color: bgMusicOn && bgMode === "synth" ? T.accent : T.textDim, transition: "all 0.2s",
              }}>{bgMusicOn && bgMode === "synth" ? "■" : "▷"} Back in the 90's (synth)</button>
            </div>
          </div>

          {/* Spotify embed — shows when spotify mode is active */}
          {bgMusicOn && bgMode === "spotify" && (
            <div style={{ marginBottom: "16px" }}>
              <iframe
                src="https://open.spotify.com/embed/track/5d4ERnrRRe9o4I7aFLFTvP?utm_source=generator&theme=0"
                width="100%" height="80" frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                style={{ borderRadius: "6px", border: `1px solid ${T.border}` }}
              />
            </div>
          )}

          {!isSpecial && (
            <div style={{ marginBottom: "16px" }}>
              <Input value={query} onChange={e => setQuery(e.target.value)} placeholder="Search quotes, characters, episodes..." />
            </div>
          )}

          {showSeason && (
            <SeasonBar season={season} setSeason={setSeason} />
          )}

          <div style={{ display: "flex", gap: "0", borderTop: `1px solid ${T.border}`, marginTop: "4px", overflowX: "auto", WebkitOverflowScrolling: "touch", scrollbarWidth: "none" }}>
            {TABS.map(t => (
              <button key={t.key} onClick={() => setTab(t.key)} style={{ background: "none", border: "none", borderBottom: `2px solid ${tab === t.key ? T.accent : "transparent"}`, color: tab === t.key ? T.text : T.textDim, cursor: "pointer", padding: "10px 14px", fontSize: "13px", fontFamily: mono, transition: "all 0.12s", marginBottom: "-1px", flexShrink: 0, whiteSpace: "nowrap" }}
                onMouseEnter={e => { if (tab !== t.key) e.currentTarget.style.color = T.textMid; }}
                onMouseLeave={e => { if (tab !== t.key) e.currentTarget.style.color = T.textDim; }}
              >{t.label}</button>
            ))}
            {query && !isSpecial && <span style={{ marginLeft: "auto", alignSelf: "center", fontFamily: mono, fontSize: "11px", color: T.textDim, paddingBottom: "2px" }}>{total} results</span>}
          </div>
        </div>
      </div>

      {/* Content */}
      <div style={{ maxWidth: "780px", margin: "0 auto", padding: "28px 32px 80px", position: "relative" }}>

        {tab === "journal" && <JournalTab />}
        {tab === "chat" && <ChatTab />}

        {/* ── AI GENERATOR ── */}
        {tab === "ai" && (
          <div>
            <Divider label="voices" />
            {/* disclaimer */}
            <div style={{ padding: "6px 0 14px" }}>
              <span style={{ fontSize: "11px", fontFamily: mono, color: T.textDim }}>
                voices inspired by the characters of <span style={{ color: T.accent }}>✦ BoJack Horseman</span> · not actual dialogue from the show
              </span>
            </div>
            <div style={{ ...card, padding: "20px", marginBottom: "16px" }}>
              {[["character", AI_CHARS, aiChar, setAiChar], ["tone", MOODS, aiMood, setAiMood]].map(([label, opts, val, setter]) => (
                <div key={label} style={{ marginBottom: "16px" }}>
                  <div style={{ fontFamily: mono, fontSize: "11px", color: T.textDim, marginBottom: "8px", textTransform: "uppercase", letterSpacing: "0.08em" }}>{label}</div>
                  <div style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}>
                    {opts.map(o => <Tag key={o} active={val === o} onClick={() => setter(o)} label={o} />)}
                  </div>
                </div>
              ))}
              <div style={{ marginBottom: "18px" }}>
                <div style={{ fontFamily: mono, fontSize: "11px", color: T.textDim, marginBottom: "8px", textTransform: "uppercase", letterSpacing: "0.08em" }}>topic <span style={{ opacity: 0.4 }}>(optional)</span></div>
                <Input value={aiTopic} onChange={e => setAiTopic(e.target.value)} onKeyDown={e => e.key === "Enter" && !aiLoading && generate()} placeholder="failure, love, time, identity, ambition, legacy, forgiveness..." />
              </div>
              <Btn primary onClick={generate} disabled={aiLoading}>{aiLoading ? "generating..." : "generate voice"}</Btn>
            </div>

            {aiLoading && <div style={{ ...card, padding: "32px", textAlign: "center" }}><p style={{ fontFamily: mono, fontSize: "12px", color: T.textDim, margin: 0 }}>thinking...</p></div>}
            {aiError && !aiLoading && <div style={{ ...card, padding: "16px", borderColor: "#3a2020" }}><p style={{ fontFamily: mono, fontSize: "12px", color: "#c47a7a", margin: 0 }}>{aiError}</p></div>}
            {aiResult && !aiLoading && (
              <div style={{ ...card, padding: "24px", borderColor: T.accentDim }}>
                <p style={{ fontSize: "16px", lineHeight: 1.75, color: T.white, margin: "0 0 16px", fontFamily: sans }}>"{aiResult.quote}"</p>
                <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "8px", marginBottom: "16px" }}>
                  <span style={{ fontFamily: mono, fontSize: "12px", color: T.accent }}>— {aiChar}</span>
                  <span style={{ fontFamily: mono, fontSize: "11px", color: T.textDim, maxWidth: "55%", textAlign: "right" }}>{aiResult.context}</span>
                </div>
                <div style={{ borderTop: `1px solid ${T.border}`, paddingTop: "12px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontFamily: mono, fontSize: "11px", color: T.textDim }}>{aiMood}{aiTopic ? ` · ${aiTopic}` : ""}</span>
                  <Btn small onClick={generate}>regenerate</Btn>
                </div>
              </div>
            )}
            {!aiResult && !aiLoading && !aiError && <p style={{ fontFamily: mono, fontSize: "12px", color: T.textDim, textAlign: "center", padding: "16px 0" }}>configure above and generate</p>}
          </div>
        )}

        {/* ── SEARCH RESULTS ── */}
        {!isSpecial && (
          <>
            {(tab === "all" || tab === "episodes") && filtered.episodes.length > 0 && (
              <section key={`eps-${query}-${season}`} style={{ marginBottom: "36px" }}>
                {tab === "all" && <Divider label={`episodes (${filtered.episodes.length})`} />}
                <div style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
                  {filtered.episodes.map((ep, idx) => {
                    const isFinale = ep.season === 6 && ep.ep === 16;
                    const isOpen = expandedEp === ep.id;
                    const epQuotes = QUOTES.filter(q => q.episode === ep.title);
                    const voices = [...new Set(epQuotes.map(q => q.character))];
                    const tone = EPISODE_TONES[ep.title];
                    const toggleOpen = () => setExpandedEp(isOpen ? null : ep.id);
                    const isNewSeason = idx === 0 || filtered.episodes[idx - 1].season !== ep.season;

                    return (
                      <React.Fragment key={ep.id}>
                      {isNewSeason && <SeasonMusicBlock season={ep.season} />}
                      <div style={{
                        ...card,
                        padding: isFinale ? "22px 20px" : "14px 16px",
                        cursor: "pointer",
                        animation: `fadeUp 0.2s ease both`,
                        animationDelay: `${Math.min(idx * 35, 300)}ms`,
                        ...(isFinale ? {
                          borderColor: isOpen ? "#7a9aaa" : "#4a5a6a",
                          borderLeftWidth: "2px",
                          borderLeftColor: "#6a8a9a",
                          background: "linear-gradient(to right, #0f1318, #111111)",
                        } : {
                          borderColor: isOpen ? T.borderFocus : T.border,
                        })
                      }}
                        onClick={toggleOpen}
                        onMouseEnter={e => { if (!isOpen) e.currentTarget.style.borderColor = isFinale ? "#7a9aaa" : T.borderFocus; }}
                        onMouseLeave={e => { if (!isOpen) e.currentTarget.style.borderColor = isFinale ? "#4a5a6a" : T.border; }}
                      >
                        {/* ── collapsed header ── */}
                        <div style={{ display: "flex", gap: "14px" }}>
                          <div style={{ fontFamily: mono, fontSize: "11px", color: isFinale ? "#6a8a9a" : T.textDim, flexShrink: 0, paddingTop: isFinale ? "4px" : "2px", minWidth: "36px" }}>
                            S{ep.season}E{ep.ep}
                          </div>
                          <div style={{ flex: 1 }}>
                            {isFinale && (
                              <div style={{ fontFamily: mono, fontSize: "10px", color: "#6a8a9a", letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: "8px" }}>
                                series finale
                              </div>
                            )}
                            <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: "8px" }}>
                              <div style={{ fontSize: isFinale ? "16px" : "14px", color: T.white, marginBottom: "4px", fontWeight: isFinale ? 400 : 500, fontFamily: sans, letterSpacing: isFinale ? "0.01em" : 0 }}>{hl(ep.title)}</div>
                              <span style={{ fontFamily: mono, fontSize: "11px", color: T.textDim, flexShrink: 0 }}>{isOpen ? "−" : "+"}</span>
                            </div>
                            <div style={{ fontSize: "13px", color: isFinale ? "#cccccc" : T.textMid, lineHeight: 1.65, fontFamily: sans, fontStyle: isFinale ? "italic" : "normal" }}>{hl(ep.description)}</div>
                          </div>
                        </div>

                        {/* ── expanded content ── */}
                        {isOpen && (
                          <div style={{ marginTop: "18px", paddingTop: "18px", borderTop: `1px solid ${T.border}`, marginLeft: "50px" }} onClick={e => e.stopPropagation()}>

                            {/* tone */}
                            {tone && (
                              <div style={{ marginBottom: "16px" }}>
                                <span style={{ fontFamily: mono, fontSize: "10px", color: T.textDim, letterSpacing: "0.1em", textTransform: "uppercase" }}>{tone}</span>
                              </div>
                            )}

                            {/* voices */}
                            {voices.length > 0 && (
                              <div style={{ marginBottom: "18px" }}>
                                <div style={{ fontFamily: mono, fontSize: "10px", color: T.textDim, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: "8px" }}>voices in this episode</div>
                                <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                                  {voices.map(v => (
                                    <span key={v} style={{ fontFamily: mono, fontSize: "11px", color: T.accent, background: "#0f1a0f", border: `1px solid ${T.accentDim}`, borderRadius: "3px", padding: "2px 8px" }}>{v}</span>
                                  ))}
                                </div>
                              </div>
                            )}

                            {/* quotes */}
                            {epQuotes.length > 0 && (
                              <div>
                                <div style={{ fontFamily: mono, fontSize: "10px", color: T.textDim, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: "10px" }}>quotes</div>
                                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                                  {epQuotes.map(q => (
                                    <div key={q.id} style={{ borderLeft: `1px solid ${isFinale ? "#4a5a6a" : T.accentDim}`, paddingLeft: "14px" }}>
                                      <p style={{ margin: "0 0 6px", fontSize: "13px", lineHeight: 1.65, color: T.text, fontFamily: sans }}>"{q.text}"</p>
                                      <span style={{ fontFamily: mono, fontSize: "11px", color: isFinale ? "#6a8a9a" : T.accent }}>— {q.character}</span>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}

                            {epQuotes.length === 0 && voices.length === 0 && (
                              <p style={{ fontFamily: mono, fontSize: "12px", color: T.textDim, margin: 0 }}>no quotes archived for this episode yet.</p>
                            )}
                          </div>
                        )}
                      </div>
                      </React.Fragment>
                    );
                  })}
                </div>
              </section>
            )}

            {(tab === "all" || tab === "quotes") && filtered.quotes.length > 0 && (
              <section key={`quotes-${query}-${season}`} style={{ marginBottom: "36px" }}>
                {tab === "all" && <Divider label={`quotes (${filtered.quotes.length})`} />}
                <div style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
                  {filtered.quotes.map((q, idx) => (
                    <div key={q.id} style={{ ...card, padding: "16px 18px", animation: `fadeUp 0.2s ease both`, animationDelay: `${Math.min(idx * 35, 300)}ms` }}
                      onMouseEnter={e => e.currentTarget.style.borderColor = T.borderFocus}
                      onMouseLeave={e => e.currentTarget.style.borderColor = T.border}
                    >
                      <p style={{ margin: "0 0 10px", fontSize: "15px", lineHeight: 1.7, color: T.white, fontFamily: sans }}>"{hl(q.text)}"</p>
                      <div style={{ display: "flex", gap: "12px", fontFamily: mono, fontSize: "11px", color: T.textDim }}>
                        <span style={{ color: T.accent }}>— {hl(q.character)}</span>
                        <span>S{q.season} · {hl(q.episode)}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {(tab === "all" || tab === "characters") && filtered.characters.length > 0 && (
              <section key={`chars-${query}-${season}`} style={{ marginBottom: "36px" }}>
                {tab === "all" && <Divider label={`characters (${filtered.characters.length})`} />}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1px" }}>
                  {filtered.characters.map((c, idx) => (
                    <div key={c.id} style={{ ...card, padding: "16px", animation: `fadeUp 0.2s ease both`, animationDelay: `${Math.min(idx * 35, 300)}ms` }}
                      onMouseEnter={e => e.currentTarget.style.borderColor = T.borderFocus}
                      onMouseLeave={e => e.currentTarget.style.borderColor = T.border}
                    >
                      <div style={{ fontSize: "14px", color: T.white, fontWeight: 500, marginBottom: "6px", fontFamily: sans }}>{hl(c.name)}</div>
                      <p style={{ margin: "0 0 10px", fontSize: "13px", lineHeight: 1.6, color: T.textMid, fontFamily: sans }}>{hl(c.description)}</p>
                      <div style={{ fontFamily: mono, fontSize: "11px", color: T.textDim }}>{c.species} · {hl(c.actor)}</div>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {(query || season) && total === 0 && (
              <div style={{ padding: "60px 0", textAlign: "center" }}>
                <p style={{ fontFamily: mono, fontSize: "13px", color: T.textDim, margin: 0 }}>no results found</p>
              </div>
            )}

            {!query && !season && tab === "all" && (
              <div style={{ marginTop: "24px", paddingTop: "16px", borderTop: `1px solid ${T.border}`, textAlign: "center" }}>
                <span style={{ fontFamily: mono, fontSize: "11px", color: T.textDim }}>{QUOTES.length} quotes · {CHARACTERS.length} characters · {EPISODES.length} episodes</span>
              </div>
            )}
          </>
        )}

      {/* Source link */}
      <div style={{ marginTop: "60px", paddingTop: "16px", borderTop: `1px solid ${T.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontFamily: mono, fontSize: "11px", color: T.textDim }}>✦ every day it gets a little easier</span>
        <a href="https://github.com/lanfeima/back-in-the-90s" target="_blank" rel="noopener noreferrer"
          style={{ fontFamily: mono, fontSize: "11px", color: T.textDim, textDecoration: "none", transition: "color 0.12s" }}
          onMouseEnter={e => e.target.style.color = T.textMid}
          onMouseLeave={e => e.target.style.color = T.textDim}
        >source code →</a>
      </div>
      </div>
    </div>
  );
}
